import { Level } from "./baseTypes";

const Boards: Level[] = [
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
    ],
    "Id": -1,
    "Items": [
      "################",
      "################",
      "################",
      "#####.....######",
      "####.......#####",
      "####.*...*.#####",
      "####.......#####",
      "#####.....######",
      "################",
      "################",
      "################",
      "################",
    ],
    "RobotRow": 5,
    "RobotCol": 7,
    "RobotDir": 0,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "igor",
    "SubmittedDate": "2009-09-30T13:02:26.15",
    "Title": "Tutorial: Part 1",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
    ],
    "Id": -2,
    "Items": [
      "################",
      "################",
      "################",
      "#####.....######",
      "####.......#####",
      "####.*...*.#####",
      "####.......#####",
      "#####.....######",
      "################",
      "################",
      "################",
      "################",
    ],
    "RobotRow": 5,
    "RobotCol": 7,
    "RobotDir": 0,
    "SubLengths": [5, 2, 0, 0, 0],
    "SubmittedBy": "igor",
    "SubmittedDate": "2009-09-30T13:02:26.15",
    "Title": "Tutorial: Part 2",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
    ],
    "Id": -3,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "###..........###",
      "###.********.###",
      "###..........###",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "RobotRow": 5,
    "RobotCol": 3,
    "RobotDir": 0,
    "SubLengths": [2, 0, 0, 0, 0],
    "SubmittedBy": "igor",
    "SubmittedDate": "2009-09-30T13:02:26.15",
    "Title": "Tutorial: Part 3",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "Id": -4,
    "Items": [
      "################",
      "################",
      "####.*******####",
      "###########*####",
      "###########*####",
      "###########*####",
      "###########*####",
      "###########*####",
      "###########*####",
      "################",
      "################",
      "################"
    ],
    "RobotRow": 2,
    "RobotCol": 4,
    "RobotDir": 0,
    "SubLengths": [3, 0, 0, 0, 0],
    "SubmittedBy": "igor",
    "SubmittedDate": "2009-09-30T13:02:26.15",
    "Title": "Tutorial: Part 4",
  },
  {
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRBBBGRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 0,
    "DifficultyVoteSum": 0,
    "Disliked": 0,
    "Featured": false,
    "Id": 17299,
    "Items": [
      "################",
      "################",
      "################",
      "##########*#####",
      "##########.#####",
      "##########.#####",
      "#######...*#####",
      "##########.#####",
      "##########.#####",
      "##########*#####",
      "################",
      "################"
    ],
    "Liked": 0,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 1,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "hiitsme4",
    "SubmittedDate": "2024-05-27T09:28:49.28",
    "Title": "Tutorial: Part 5"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRRRBRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 18,
    "DifficultyVoteSum": 18,
    "Disliked": 6,
    "Featured": false,
    "Id": 16161,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "#######*..######",
      "#########.######",
      "#######...######",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 35,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 774,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "hiitsme",
    "SubmittedDate": "2023-10-02T15:27:38.72",
    "Title": "Lightbot 1-2",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 10,
    "DifficultyVoteSum": 13,
    "Disliked": 6,
    "Featured": false,
    "Id": 16163,
    "Items": [
      "################",
      "################",
      "######*..#######",
      "######...#######",
      "######*.*#######",
      "######...#######",
      "######..*#######",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 9,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 96,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "hiitsme",
    "SubmittedDate": "2023-10-02T15:32:28.193",
    "Title": "Lightbot 1-6",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 8,
    "DifficultyVoteSum": 12,
    "Disliked": 5,
    "Featured": false,
    "Id": 16165,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "#######.**######",
      "#######.**######",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 6,
    "RobotCol": 7,
    "RobotDir": 1,
    "RobotRow": 6,
    "Solutions": 66,
    "SubLengths": [7, 0, 0, 0, 0],
    "SubmittedBy": "hiitsme",
    "SubmittedDate": "2023-10-02T15:37:20.393",
    "Title": "Lightbot 1-7",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRBBBBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 6,
    "DifficultyVoteSum": 8,
    "Disliked": 3,
    "Featured": false,
    "Id": 16166,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "#######.***#####",
      "##########*#####",
      "##########*#####",
      "#######****#####",
      "################",
      "################",
    ],
    "Liked": 3,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 71,
    "SubLengths": [3, 4, 0, 0, 0],
    "SubmittedBy": "hiitsme2",
    "SubmittedDate": "2023-10-02T15:47:39.193",
    "Title": "Lightbot 2-1",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRBRRRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 7,
    "DifficultyVoteSum": 10,
    "Disliked": 4,
    "Featured": false,
    "Id": 16167,
    "Items": [
      "################",
      "################",
      "###########*####",
      "##########..####",
      "#########..#####",
      "########..######",
      "#######.*#######",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 5,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 68,
    "SubLengths": [4, 4, 0, 0, 0],
    "SubmittedBy": "hiitsme2",
    "SubmittedDate": "2023-10-02T15:53:43.81",
    "Title": "Lightbot 2-2",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBBRRRRR",
      "RRRRRRRBBBBRRRRR",
      "RRRRRRRBBBBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 11,
    "DifficultyVoteSum": 12,
    "Disliked": 6,
    "Featured": false,
    "Id": 16168,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "#######...*#####",
      "#######*...#####",
      "#######...*#####",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 10,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 156,
    "SubLengths": [9, 3, 0, 0, 0],
    "SubmittedBy": "hiitsme2",
    "SubmittedDate": "2023-10-02T15:57:03.893",
    "Title": "Lightbot 2-3",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRRRRRBRRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 5,
    "DifficultyVoteSum": 10,
    "Disliked": 1,
    "Featured": false,
    "Id": 16169,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "#######.****####",
      "###########.####",
      "#######****.####",
      "#######.########",
      "#######.****####",
      "################",
    ],
    "Liked": 2,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 64,
    "SubLengths": [9, 4, 2, 0, 0],
    "SubmittedBy": "hiitsme2",
    "SubmittedDate": "2023-10-02T16:00:49.197",
    "Title": "Lightbot 2-4",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 6,
    "DifficultyVoteSum": 12,
    "Disliked": 0,
    "Featured": false,
    "Id": 16170,
    "Items": [
      "################",
      "################",
      "#######****.####",
      "###########.####",
      "######*****.####",
      "##########.#####",
      "#####*****.#####",
      "#########.######",
      "####*****.######",
      "################",
      "################",
      "################",
    ],
    "Liked": 1,
    "RobotCol": 11,
    "RobotDir": 2,
    "RobotRow": 2,
    "Solutions": 74,
    "SubLengths": [8, 5, 10, 0, 0],
    "SubmittedBy": "hiitsme2",
    "SubmittedDate": "2023-10-02T16:10:03.863",
    "Title": "Lightbot 2-5",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRBBBBBRRRRRRR",
      "RRRRBBBBBRRRRRRR",
      "RRRRBBBBBRRRRRRR",
      "RRRRBBBBBRRRRRRR",
      "RRRRBBBBBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 6,
    "DifficultyVoteSum": 10,
    "Disliked": 1,
    "Featured": false,
    "Id": 16171,
    "Items": [
      "################",
      "################",
      "####**.**#######",
      "####**.**#######",
      "####.....#######",
      "####**.**#######",
      "####**.*.#######",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 3,
    "RobotCol": 8,
    "RobotDir": 3,
    "RobotRow": 6,
    "Solutions": 71,
    "SubLengths": [9, 8, 8, 0, 0],
    "SubmittedBy": "hiitsme3",
    "SubmittedDate": "2023-10-02T16:16:21.14",
    "Title": "Lightbot 2-6",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRGGGGGRRRRRR",
      "RRRRRGRRRGRRRRRR",
      "RRRRRGRRRGRRRRRR",
      "RRRRRGRRRGRRRRRR",
      "RRRRRGGGGGRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 31,
    "DifficultyVoteSum": 38,
    "Disliked": 8,
    "Featured": false,
    "Id": 13946,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "#####*****######",
      "#####*###*######",
      "#####*###*######",
      "#####*###*######",
      "#####.****######",
      "################",
      "################",
      "################",
    ],
    "Liked": 40,
    "RobotCol": 5,
    "RobotDir": 3,
    "RobotRow": 8,
    "Solutions": 359,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "Roses",
    "SubmittedDate": "2021-09-27T18:26:37.06",
    "Title": "Green Square",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRBBRR",
      "RRRRRRRRRRRBBRRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRBBRRRRRRRR",
      "RRRRRBBRRRRRRRRR",
      "RRRRBBRRRRRRRRRR",
      "RRRBBRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 15075,
    "DifficultyVoteCount": 6218,
    "DifficultyVoteSum": 8662,
    "Disliked": 548,
    "Featured": true,
    "Id": 27,
    "Items": [
      "################",
      "############**##",
      "###########**###",
      "##########**####",
      "#########**#####",
      "########**######",
      "#######**#######",
      "######**########",
      "#####**#########",
      "####**##########",
      "###.*###########",
      "################"
    ],
    "Liked": 6079,
    "RobotCol": 3,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 132114,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": { "-i:nil": "true" },
    "SubmittedDate": "2008-12-15T04:03:43",
    "Title": "Stairs"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRBR",
      "RRRRRRRRRRRRBBRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRBBRRRRRRRR",
      "RRRRBBRRRRRRRRRR",
      "RRBBRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 27,
    "DifficultyVoteSum": 31,
    "Disliked": 6,
    "Featured": false,
    "Id": 14133,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "##############.*",
      "############..*#",
      "##########..*###",
      "########..*#####",
      "######..*#######",
      "####..*#########",
      "##..*###########",
    ],
    "Liked": 33,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 350,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "Fantastic_Four",
    "SubmittedDate": "2021-10-03T21:57:54.393",
    "Title": "Elongated Stairs",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRRBRRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRBBRRRRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 27,
    "DifficultyVoteSum": 31,
    "Disliked": 4,
    "Featured": false,
    "Id": 13904,
    "Items": [
      "##########*#####",
      "##########.#####",
      "#########*.#####",
      "#########.######",
      "########*.######",
      "########.#######",
      "#######*.#######",
      "#######.########",
      "######*.########",
      "######.#########",
      "######.#########",
      "################",
    ],
    "Liked": 34,
    "RobotCol": 6,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 437,
    "SubLengths": [8, 0, 0, 0, 0],
    "SubmittedBy": "Group1ENGR101",
    "SubmittedDate": "2021-09-23T12:00:18.237",
    "Title": "Compressed Stairs",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRBRRR",
      "RRRRRRRRRRRBBRRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRRRRBBRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 28,
    "DifficultyVoteSum": 34,
    "Disliked": 10,
    "Featured": false,
    "Id": 14343,
    "Items": [
      "################",
      "############*###",
      "###########..###",
      "##########..####",
      "#########..#####",
      "########..######",
      "#######..#######",
      "########..######",
      "#########..#####",
      "##########..####",
      "###########..###",
      "################",
    ],
    "Liked": 34,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 321,
    "SubLengths": [3, 5, 0, 0, 0],
    "SubmittedBy": "4pmgroup5",
    "SubmittedDate": "2021-10-05T20:38:12.787",
    "Title": "Up and Down Stairs",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BRRRRRRRRBRRRRRR",
      "BBBBBBBBBBRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 32,
    "DifficultyVoteSum": 39,
    "Disliked": 3,
    "Featured": false,
    "Id": 15109,
    "Items": [
      "**********######",
      "*########*######",
      "*########*######",
      "*########*######",
      "*########*######",
      "*########*######",
      "*########*######",
      "*########*######",
      "*########*######",
      ".*********######",
      "################",
      "################",
    ],
    "Liked": 38,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 9,
    "Solutions": 421,
    "SubLengths": [10, 2, 0, 0, 0],
    "SubmittedBy": "Idunn0",
    "SubmittedDate": "2023-05-18T18:34:31.517",
    "Title": "10x10 Square",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 28,
    "DifficultyVoteSum": 32,
    "Disliked": 6,
    "Featured": false,
    "Id": 14737,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "#######*****####",
      "#######.****####",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 39,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 364,
    "SubLengths": [8, 0, 0, 0, 0],
    "SubmittedBy": "Buzzle",
    "SubmittedDate": "2022-02-17T00:51:43.97",
    "Title": "Wiggly Wobbly",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBBBGRRR",
      "RRRRRRRRRRRRBRRR",
      "RRRRRRRRRRRRBRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 31,
    "DifficultyVoteSum": 33,
    "Disliked": 8,
    "Featured": false,
    "Id": 14060,
    "Items": [
      "################",
      "################",
      "################",
      "#######*.....###",
      "############.###",
      "############.###",
      "#######......###",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 37,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 403,
    "SubLengths": [10, 10, 0, 0, 0],
    "SubmittedBy": "Group5Project",
    "SubmittedDate": "2021-10-02T20:41:18.437",
    "Title": "Iteration",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RBBBBBBBBBBBBBBR",
      "BRBBBBBBBBBBBBRB",
      "BBRBBBBBBBBBBRBB",
      "BBBRBBBBBBBBRBBB",
      "BBBBRBBBBBBRBBBB",
      "BBBBBBBBBBRBBBBB",
      "BBBBRBBBBBRBBBBB",
      "BBBRBBBBBBBRBBBB",
      "BBRBBBBBBBBBRBBB",
      "BRBBBBBBBBBBBRBB",
      "RBBBBBBBBBBBBBRB",
      "BBBBBBBBBBBBBBBR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 19,
    "DifficultyVoteSum": 25,
    "Disliked": 5,
    "Featured": false,
    "Id": 13110,
    "Items": [
      "*..............*",
      ".*............*.",
      "..*..........*..",
      "...*........*...",
      "....*......*....",
      "..........*.....",
      "....*.....*.....",
      "...*.......*....",
      "..*.........*...",
      ".*...........*..",
      "*.............*.",
      "...............*",
    ],
    "Liked": 23,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 213,
    "SubLengths": [2, 2, 0, 0, 0],
    "SubmittedBy": "SKEBS",
    "SubmittedDate": "2020-10-09T18:57:31.713",
    "Title": "Every Single One",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "BBBBBBBBBBBRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 23,
    "DifficultyVoteSum": 35,
    "Disliked": 1,
    "Featured": false,
    "Id": 15126,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "###############*",
      "##############..",
      "#############..#",
      "############..##",
      "###########..###",
      "............####",
    ],
    "Liked": 34,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 243,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "Idunn0",
    "SubmittedDate": "2023-05-31T12:56:16.093",
    "Title": "Hallway to Stairs",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRBBBBBBBBBRR",
      "RRRRRBBBBRBBBBRR",
      "RRRRRBBBRRRBBBRR",
      "RRRRRBBRRGRRBBRR",
      "RRRRRBBBRRRBBBRR",
      "RRRRRBBBBRBBBBRR",
      "RRRRRBBBBGBBBBRR",
      "RRRRRBBBBGBBBBRR",
      "RRRRRBBBBGBBBBRR",
      "RRRRRBBBBBBBBBRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 22,
    "DifficultyVoteSum": 24,
    "Disliked": 6,
    "Featured": false,
    "Id": 14261,
    "Items": [
      "#####.........##",
      "#####.........##",
      "#####.........##",
      "#####....*....##",
      "#####.........##",
      "#####.........##",
      "#####.........##",
      "#####.........##",
      "#####.........##",
      "#####.........##",
      "################",
      "################",
    ],
    "Liked": 29,
    "RobotCol": 5,
    "RobotDir": 0,
    "RobotRow": 9,
    "Solutions": 254,
    "SubLengths": [9, 0, 0, 0, 0],
    "SubmittedBy": "MORF2",
    "SubmittedDate": "2021-10-04T20:37:06.793",
    "Title": "Confusing Flower",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRBBBBBBBBBRRR",
      "RRRRBGBBBBRBBRRR",
      "RRRRBBBBBBBBBRRR",
      "RRRRBBBBBBBBBRRR",
      "RRRRBRBBBBBBBRRR",
      "RRRRBBBBBBGBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 43,
    "DifficultyVoteSum": 47,
    "Disliked": 12,
    "Featured": false,
    "Id": 12986,
    "Items": [
      "################",
      "####.........###",
      "####..****...###",
      "####.*....*..###",
      "####.*....*..###",
      "####.********###",
      "####....**...###",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 57,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 509,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "_Group_8",
    "SubmittedDate": "2020-10-01T13:40:57.733",
    "Title": "Round and Round",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRGBBBBBGRRRRR",
      "RRRRBRRRRRBRRRRR",
      "RRRRBRRRRRBRRRRR",
      "RRBBGBBRRRBRRRRR",
      "RRRRBRRBRRBRRRRR",
      "RRRRRBBRRRBRRRRR",
      "RRRRRRRRRBGBRRRR",
      "RRRRRRRRBRBRRRRR",
      "RRRRRRRRBRBRRRRR",
      "RRRRRRRRBRBRRRRR",
      "RRRRRRRRRBRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 22,
    "DifficultyVoteSum": 28,
    "Disliked": 5,
    "Featured": false,
    "Id": 14218,
    "Items": [
      "################",
      "####*.....*#####",
      "####.#####.#####",
      "####.#####.#####",
      "##..*..*##.#####",
      "####.##.##.#####",
      "####*..*##.#####",
      "########*.*.####",
      "########.#.#####",
      "########.#.#####",
      "########.#.#####",
      "########***#####",
    ],
    "Liked": 25,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 4,
    "Solutions": 143,
    "SubLengths": [3, 2, 2, 0, 0],
    "SubmittedBy": "bruhboys",
    "SubmittedDate": "2021-10-04T15:34:42.433",
    "Title": "Round and Round and Round",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRBBBRRRRRRBBBRR",
      "RRBRBRRRRRRBRBRR",
      "RRBBGGGGGGGGBBRR",
      "RRRRGRRRRRRGRRRR",
      "RRRRGRRRRRRGRRRR",
      "RRRRGRRRRRRGRRRR",
      "RRRRGRRRRRRGRRRR",
      "RRRRGRRRRRRGRRRR",
      "RRBBGGGGGGGGBBRR",
      "RRBRBRRRRRRBRBRR",
      "RRBBBRRRRRRBBBRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 24,
    "DifficultyVoteSum": 47,
    "Disliked": 0,
    "Featured": false,
    "Id": 15093,
    "Items": [
      "##***######***##",
      "##*#*######*#*##",
      "##**........**##",
      "####.######.####",
      "####.######.####",
      "####.######.####",
      "####.######.####",
      "####.######.####",
      "##**........**##",
      "##*#*######*#*##",
      "##***######***##",
      "################",
    ],
    "Liked": 25,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 2,
    "Solutions": 129,
    "SubLengths": [4, 0, 0, 0, 0],
    "SubmittedBy": "pschbb12",
    "SubmittedDate": "2023-04-04T10:13:30.05",
    "Title": "Corner Loops",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBBBBBBBBBBBBBBB",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 394,
    "DifficultyVoteCount": 4898,
    "DifficultyVoteSum": 7721,
    "Disliked": 423,
    "Featured": false,
    "Id": 140,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      ".........*******",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 4510,
    "RobotCol": 8,
    "RobotDir": 2,
    "RobotRow": 6,
    "Solutions": 78786,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "sam0737",
    "SubmittedDate": "2009-03-14T22:36:49.25",
    "Title": "Turn Around"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRGBBBBBBGRRR",
      "RRRRRBRRRRRRBRRR",
      "RRRRRBRRRRRRBRRR",
      "RRRRRBRBBBBBGRRR",
      "RRRRRBRRRRRRRRRR",
      "RRRBRGRGRRRRRRRR",
      "RRRBRRBRRRRRRRRR",
      "RRRGBBGRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 313,
    "DifficultyVoteCount": 3551,
    "DifficultyVoteSum": 8933,
    "Disliked": 151,
    "Featured": false,
    "Id": 644,
    "Items": [
      "################",
      "################",
      "################",
      "#####........###",
      "#####.######.###",
      "#####.######.###",
      "#####.#......###",
      "#####.##########",
      "###*#...########",
      "###.##.#########",
      "###....#########",
      "################"
    ],
    "Liked": 3376,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 44534,
    "SubLengths": [5, 4, 0, 0, 0],
    "SubmittedBy": "sarsdp",
    "SubmittedDate": "2009-06-03T18:59:04.517",
    "Title": "Right on Red"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRGR",
      "RBRRRRRRRRRRRRGR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 241,
    "DifficultyVoteCount": 4511,
    "DifficultyVoteSum": 7035,
    "Disliked": 387,
    "Featured": false,
    "Id": 105,
    "Items": [
      "################",
      "################",
      "################",
      "#..............#",
      "#.############*#",
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 3639,
    "RobotCol": 1,
    "RobotDir": 3,
    "RobotRow": 4,
    "Solutions": 47990,
    "SubLengths": [4, 0, 0, 0, 0],
    "SubmittedBy": "jacob_c",
    "SubmittedDate": "2009-03-07T16:54:07.39",
    "Title": "Zipline"
  },
  {
    "About": "There is a short solution.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRGGGGGGGGGGRRR",
      "RRRBBBBBBBBBBRRR",
      "RRRBBBBBBBBBBRRR",
      "RRRBBBBBBBBBBRRR",
      "RRRBBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 218,
    "DifficultyVoteCount": 4262,
    "DifficultyVoteSum": 7197,
    "Disliked": 229,
    "Featured": true,
    "Id": 23,
    "Items": [
      "################",
      "################",
      "################",
      "###..........###",
      "###*.*.*.*...###",
      "###.*.*.*.*..###",
      "###..*.*.*.*.###",
      "###...*.*.*.*###",
      "###..........###",
      "################",
      "################",
      "################"
    ],
    "Liked": 3763,
    "RobotCol": 3,
    "RobotDir": 3,
    "RobotRow": 5,
    "Solutions": 42541,
    "SubLengths": [4, 0, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2008-12-15T03:32:01.673",
    "Title": "Two Stripes"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RBRRRBRRRBRRRBRR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRGRBRGRBRGRBRGR",
      "BRRGRRRGRRRGRRRG"
    ],
    "CommentCount": 837,
    "DifficultyVoteCount": 3292,
    "DifficultyVoteSum": 7461,
    "Disliked": 109,
    "Featured": false,
    "Id": 634,
    "Items": [
      "...#...#...#...#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#...#...#...#.*"
    ],
    "Liked": 3050,
    "RobotCol": 0,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 33526,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "timotheeee",
    "SubmittedDate": "2009-06-02T11:35:20.983",
    "Title": "Mountains"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRGRRRRRRR",
      "RRRRRRBRBBRRRRRR",
      "RRRRRBRBBRBRRRRR",
      "RRRRGBBBBBRRRRRR",
      "RRRRRRBBBBBGRRRR",
      "RRRRRBRBBRBRRRRR",
      "RRRRRRBBRBRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 289,
    "DifficultyVoteCount": 3363,
    "DifficultyVoteSum": 6928,
    "Disliked": 165,
    "Featured": false,
    "Id": 223,
    "Items": [
      "################",
      "################",
      "########*#######",
      "#####*....*#####",
      "#####.#..#.#####",
      "####*......#####",
      "#####......*####",
      "#####.#..#.#####",
      "#####*....*#####",
      "#######*########",
      "################",
      "################"
    ],
    "Liked": 3148,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 30527,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "wallacoloo",
    "SubmittedDate": "2009-03-28T18:28:13.797",
    "Title": "Right on Red, ??? on Green"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRGRGRGRGRGRRRR",
      "GBBRBBBBBBBBBBGR",
      "RRRBRBRBRBRBRRRR",
      "GBBBBRBBBBBRBBGR",
      "GBBBBBBRBRBBBBGR",
      "RRRBRBRBRBRBRRRR",
      "GBBBBBBRBBRBRRRR",
      "RRRBRBRRRBRBRRRR",
      "GBBBBRBBBRBBBBGR",
      "RRRBRBRRRBRBRRRR",
      "GBBRBBBBBBBRBBGR",
      "RRRGRGRRRGRGRRRR"
    ],
    "CommentCount": 394,
    "DifficultyVoteCount": 3348,
    "DifficultyVoteSum": 6293,
    "Disliked": 185,
    "Featured": false,
    "Id": 483,
    "Items": [
      "###*#*#*#*#*####",
      "***************#",
      "###*#*#*#*#*####",
      "***************#",
      "***************#",
      "###*#*#*#*#*####",
      "******.***#*####",
      "###*#*###*#*####",
      "***************#",
      "###*#*###*#*####",
      "***************#",
      "###*#*###*#*####"
    ],
    "Liked": 3363,
    "RobotCol": 6,
    "RobotDir": 2,
    "RobotRow": 6,
    "Solutions": 32901,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "alvarom",
    "SubmittedDate": "2009-05-09T05:36:56.983",
    "Title": "Spiral Web"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRGGGGGRRRRRR",
      "RRRRRGBGBGRRRRRR",
      "RRRRRGGBGGRRRRRR",
      "RRRRRGBGBGRRRRRR",
      "RRRRRGGGGGRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 186,
    "DifficultyVoteCount": 2987,
    "DifficultyVoteSum": 5759,
    "Disliked": 216,
    "Featured": false,
    "Id": 570,
    "Items": [
      "################",
      "################",
      "################",
      "#####*****######",
      "#####*.*.*######",
      "#####**.**######",
      "#####*.*.*######",
      "#####*****######",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 2558,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 31360,
    "SubLengths": [4, 0, 0, 0, 0],
    "SubmittedBy": "rafaelromao",
    "SubmittedDate": "2009-05-21T21:41:59.25",
    "Title": "Blue X"
  },
  {
    "About": "Green means go",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRBBGBGBBRRRRRR",
      "RRRBRRRRRBRRRRRR",
      "RRRBBBRBBBRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 121,
    "DifficultyVoteCount": 2987,
    "DifficultyVoteSum": 5080,
    "Disliked": 172,
    "Featured": false,
    "Id": 432,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "###*..*..*######",
      "###.#####.######",
      "###*.*#..*######",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 2396,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 26495,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "zephyrmation",
    "SubmittedDate": "2009-05-03T13:54:12",
    "Title": "Stoplight"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRBBBRRR",
      "RRRRRRRRRRBRBRRR",
      "RRRRRRRRBBBRBRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRRBBBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRBBBRRRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 122,
    "DifficultyVoteCount": 3153,
    "DifficultyVoteSum": 5977,
    "Disliked": 357,
    "Featured": true,
    "Id": 39,
    "Items": [
      "################",
      "################",
      "##########...###",
      "##########.#.###",
      "########...#*###",
      "########.#######",
      "########...#####",
      "##########.#####",
      "########...#####",
      "########.#######",
      "######...#######",
      "################"
    ],
    "Liked": 2555,
    "RobotCol": 6,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 20060,
    "SubLengths": [10, 3, 3, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-02-24T13:40:17.593",
    "Title": "Smart Reuse"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRBBRR",
      "RRRRRRRRRRRBBRRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRBBRRRRRRRR",
      "RRRRRBBRRRRRRRRR",
      "RRRRBBRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 146,
    "DifficultyVoteCount": 3917,
    "DifficultyVoteSum": 5186,
    "Disliked": 448,
    "Featured": true,
    "Id": 24,
    "Items": [
      "################",
      "############.*##",
      "###########..###",
      "##########..####",
      "#########..#####",
      "########..######",
      "#######..#######",
      "######..########",
      "#####..#########",
      "####..##########",
      "####.###########",
      "################"
    ],
    "Liked": 2943,
    "RobotCol": 4,
    "RobotDir": 3,
    "RobotRow": 10,
    "Solutions": 29605,
    "SubLengths": [3, 3, 0, 0, 0],
    "SubmittedBy": { "-i:nil": "true" },
    "SubmittedDate": "2008-12-15T03:45:53.843",
    "Title": "Two Functions"
  },
  {
    "About": "dizzy yet?",
    "AllowedCommands": 0,
    "Colors": [
      "RBBBBBBBBBBBBBBR",
      "BRRRRRRRRRRRRRRB",
      "BRRBBBBBBBBBBRRB",
      "BRBRRRRRRRRRRBRB",
      "BRBRRBBBBBBRRBRB",
      "BRBRBRRRRRRBRBRB",
      "BRBRBRRRRGRBRBRB",
      "BRBRRBBBBRRBRBRB",
      "BRBRRRRRRRRBRBRB",
      "BRRBBBBBBBBRRBRB",
      "BRRRRRRRRRRRRBRB",
      "RBBBBBBBBBBBBRRG"
    ],
    "CommentCount": 170,
    "DifficultyVoteCount": 2575,
    "DifficultyVoteSum": 5458,
    "Disliked": 140,
    "Featured": false,
    "Id": 539,
    "Items": [
      "................",
      ".##############.",
      ".#............#.",
      ".#.##########.#.",
      ".#.#........#.#.",
      ".#.#.######.#.#.",
      ".#.#.####*#.#.#.",
      ".#.#......#.#.#.",
      ".#.########.#.#.",
      ".#..........#.#.",
      ".############.#.",
      "..............#*"
    ],
    "Liked": 2180,
    "RobotCol": 15,
    "RobotDir": 3,
    "RobotRow": 10,
    "Solutions": 19142,
    "SubLengths": [4, 3, 3, 0, 0],
    "SubmittedBy": "ammonzing",
    "SubmittedDate": "2009-05-16T20:45:51.64",
    "Title": "Hypnotize"
  },
  {
    "About": "Easy",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 121,
    "DifficultyVoteCount": 2258,
    "DifficultyVoteSum": 5391,
    "Disliked": 147,
    "Featured": false,
    "Id": 648,
    "Items": [
      "#######*########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######*########",
      "################"
    ],
    "Liked": 1812,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 16271,
    "SubLengths": [2, 2, 2, 2, 2],
    "SubmittedBy": "rafaelromao",
    "SubmittedDate": "2009-06-03T22:41:10.11",
    "Title": "Tight Area"
  },
  {
    "About": "It's a a cross",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRBGBBRBBGBRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 21699,
    "DifficultyVoteCount": 2056,
    "DifficultyVoteSum": 4969,
    "Disliked": 71,
    "Featured": false,
    "Id": 587,
    "Items": [
      "################",
      "################",
      "#######*########",
      "#######.########",
      "#######.########",
      "#######.########",
      "###*.......*####",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######*########",
      "################"
    ],
    "Liked": 1643,
    "RobotCol": 7,
    "RobotDir": 1,
    "RobotRow": 6,
    "Solutions": 13922,
    "SubLengths": [4, 4, 0, 0, 0],
    "SubmittedBy": "diechort",
    "SubmittedDate": "2009-05-25T00:58:32.5",
    "Title": "The Cross"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBBBBBBBBBRRBRRR",
      "RBBBBBBBBRRBBRRR",
      "RBBBBBBBRRBBBRRR",
      "RBBBBBBRRBBBBRRR",
      "RBBBBBRGBBBBBRRR",
      "RBBBBRRBBBBBBRRR",
      "RBBBRRBBBBBBBRRR",
      "RBBRRBBBBBBBBRRR",
      "RBRRBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 290,
    "DifficultyVoteCount": 3214,
    "DifficultyVoteSum": 5180,
    "Disliked": 520,
    "Featured": false,
    "Id": 111,
    "Items": [
      "################",
      "**************##",
      "**********.***##",
      "**************##",
      "**************##",
      "**************##",
      "*******.******##",
      "**************##",
      "**************##",
      "**************##",
      "**************##",
      "**************##"
    ],
    "Liked": 2579,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 21479,
    "SubLengths": [3, 0, 0, 0, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-09T10:10:02.127",
    "Title": "Flooder"
  },
  {
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRBBBGRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 115,
    "DifficultyVoteCount": 2325,
    "DifficultyVoteSum": 4116,
    "Disliked": 172,
    "Featured": false,
    "Id": 419,
    "Items": [
      "################",
      "################",
      "################",
      "##########*#####",
      "##########.#####",
      "##########.#####",
      "#######...*#####",
      "##########.#####",
      "##########.#####",
      "##########*#####",
      "################",
      "################"
    ],
    "Liked": 1701,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 15209,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "pinkprince",
    "SubmittedDate": "2009-05-02T16:43:49.28",
    "Title": "Turn and Back Again"
  },
  {
    "About": "Red tile... hmmm",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRGBGBGRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 92,
    "DifficultyVoteCount": 2459,
    "DifficultyVoteSum": 4364,
    "Disliked": 189,
    "Featured": false,
    "Id": 262,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "#######.########",
      "######.*.#######",
      "#####.*.*.######",
      "######.*.#######",
      "#######.########",
      "################",
      "################",
      "################"
    ],
    "Liked": 1798,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 16448,
    "SubLengths": [3, 3, 0, 0, 0],
    "SubmittedBy": "sungjin",
    "SubmittedDate": "2009-04-03T05:18:44.453",
    "Title": "Star"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBBBBBBBBBBBBRRR",
      "BRRRRRRRRRBGRBRR",
      "BRRRRRRRRBGRBBRR",
      "BRRRRRRRBGRBRBRR",
      "BRRRRRRBGRBRRBRR",
      "BBBBBBBBRBRRRBRR",
      "RBBBBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 93,
    "DifficultyVoteCount": 2641,
    "DifficultyVoteSum": 4562,
    "Disliked": 238,
    "Featured": false,
    "Id": 72,
    "Items": [
      "################",
      "################",
      "################",
      "#............###",
      ".#########..*.##",
      ".########.....##",
      ".#######....#.##",
      ".######....##.##",
      "..........###.##",
      "#............###",
      "################",
      "################"
    ],
    "Liked": 1944,
    "RobotCol": 1,
    "RobotDir": 2,
    "RobotRow": 8,
    "Solutions": 14496,
    "SubLengths": [4, 5, 0, 0, 0],
    "SubmittedBy": "glum",
    "SubmittedDate": "2009-02-27T19:43:49.703",
    "Title": "One Star"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RGBBBBBBBBBBBBBG",
      "RBRRRRRRRRRRRRRB",
      "RBRRGBBBBBBBBGRB",
      "RBRRBRRRRRRRRBRB",
      "RBRRBRGBBBBGRBRB",
      "RBRRBRBRRRRBRBRB",
      "RBRRBRBRRRRBRBRB",
      "RBRRBRBRGBBGRBRB",
      "RBRRBRBRRRRRRBRB",
      "RBRRBRGBBBBBBGRB",
      "RBGRBRRRRRRRRRRB",
      "RGGRGBBBBBBBBBBG"
    ],
    "CommentCount": 110,
    "DifficultyVoteCount": 2180,
    "DifficultyVoteSum": 4363,
    "Disliked": 128,
    "Featured": false,
    "Id": 131,
    "Items": [
      "#...............",
      "#.#############.",
      "#.##..........#.",
      "#.##.########.#.",
      "#.##.#......#.#.",
      "#.##.#.####.#.#.",
      "#.##.#.#*##.#.#.",
      "#.##.#.#....#.#.",
      "#.##.#.######.#.",
      "#.##.#........#.",
      "*..#.##########.",
      "#..#............"
    ],
    "Liked": 1790,
    "RobotCol": 1,
    "RobotDir": 3,
    "RobotRow": 10,
    "Solutions": 13392,
    "SubLengths": [4, 3, 3, 0, 0],
    "SubmittedBy": "w4keme",
    "SubmittedDate": "2009-03-11T22:30:55.377",
    "Title": "Driving in the UK"
  },
  {
    "About": "Buzzed.",
    "AllowedCommands": 1,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRGGRGGRGGRGGR",
      "BBBBBGBBGBBGBBGB",
      "RRRRGGRGGRGGRGGR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 109,
    "DifficultyVoteCount": 1910,
    "DifficultyVoteSum": 4393,
    "Disliked": 25,
    "Featured": false,
    "Id": 571,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "####**#**#**#**#",
      ".....*..*..*..**",
      "####**#**#**#**#",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 1669,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 11448,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "thenick22",
    "SubmittedDate": "2009-05-22T03:41:04.313",
    "Title": "Bumbling Bee"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRBBBGRRRRRRRR",
      "RRRBRRRGGRRRRRRR",
      "RRRBRRRRGGRRRRRR",
      "RRRRBBRRRGGRRRRR",
      "RRRRRRRRRRGRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 77,
    "DifficultyVoteCount": 2258,
    "DifficultyVoteSum": 3992,
    "Disliked": 179,
    "Featured": false,
    "Id": 376,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "###.....########",
      "###.###..#######",
      "###.####..######",
      "###...###..#####",
      "##########*#####",
      "################",
      "################",
      "################"
    ],
    "Liked": 1627,
    "RobotCol": 5,
    "RobotDir": 2,
    "RobotRow": 7,
    "Solutions": 13557,
    "SubLengths": [8, 0, 0, 0, 0],
    "SubmittedBy": "cybermg",
    "SubmittedDate": "2009-04-24T05:50:31.343",
    "Title": "Leftovers"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRBRRRRRR",
      "RRRRRRRRRBRRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRBBBRBRRRRRRR",
      "RRRRRRBBRBBRRRRR",
      "RRRRRRRRBRBBBRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 89,
    "DifficultyVoteCount": 2053,
    "DifficultyVoteSum": 4653,
    "Disliked": 67,
    "Featured": true,
    "Id": 41,
    "Items": [
      "################",
      "################",
      "#########*######",
      "#########.######",
      "########..######",
      "####*..#.#######",
      "######.....#####",
      "########.#..*###",
      "#######..#######",
      "#######.########",
      "#######*########",
      "################"
    ],
    "Liked": 1825,
    "RobotCol": 8,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 12791,
    "SubLengths": [7, 7, 0, 0, 0],
    "SubmittedBy": "poiuy",
    "SubmittedDate": "2009-02-24T14:14:58.327",
    "Title": "The Windmill"
  },
  {
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RGBRGBRGBRGBRGBR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 79,
    "DifficultyVoteCount": 2090,
    "DifficultyVoteSum": 3889,
    "Disliked": 71,
    "Featured": false,
    "Id": 168,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "*..............*",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 1832,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 12361,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "prudnikoff",
    "SubmittedDate": "2009-03-20T08:19:58.233",
    "Title": "Simple Flattening"
  },
  {
    "About": "But I want blue bar!",
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRGGRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRGGRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 89,
    "DifficultyVoteCount": 2018,
    "DifficultyVoteSum": 3562,
    "Disliked": 98,
    "Featured": false,
    "Id": 289,
    "Items": [
      "################",
      "################",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######.*#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "################"
    ],
    "Liked": 1609,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 12215,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "sungjin",
    "SubmittedDate": "2009-04-04T23:45:17.86",
    "Title": "Colorful Bar"
  },
  {
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRBBBBRRRRRRRRR",
      "RRBRRRRBRRRRBRRR",
      "RRBRRRRBRRRBRBRR",
      "RRRBBBBGRRRBRBRR",
      "RRRRRRRBRRRBRBRR",
      "RRBBGBBRBBBGBRRR",
      "RBRRBRRBRRRRRRRR",
      "RBRRBRRGBBBBRRRR",
      "RBRRBRRBRRRRBRRR",
      "RRBBRRRRBBBBRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 96,
    "DifficultyVoteCount": 2020,
    "DifficultyVoteSum": 3619,
    "Disliked": 82,
    "Featured": false,
    "Id": 166,
    "Items": [
      "################",
      "##*....*########",
      "##.####.###*.*##",
      "##.####.###.#.##",
      "##*.....###.#.##",
      "#######.###.#.##",
      "#*...........*##",
      "#.##.##.########",
      "#.##.##.....*###",
      "#.##.##.####.###",
      "#*..*##*....*###",
      "################"
    ],
    "Liked": 1713,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 11374,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-20T02:14:06.077",
    "Title": "Left on Green... the First Time"
  },
  {
    "About": "Learn to paint",
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRBRRR",
      "RRRRRRRRRRRRBRRR",
      "RRRRRRRRRRRRBRRR",
      "RRRRRRRRBBBBGRRR",
      "RRRRRRRRRRRRGRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 63,
    "DifficultyVoteCount": 1720,
    "DifficultyVoteSum": 3446,
    "Disliked": 151,
    "Featured": false,
    "Id": 449,
    "Items": [
      "################",
      "################",
      "############*###",
      "############.###",
      "############.###",
      "############.###",
      "########.....###",
      "############*###",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 1209,
    "RobotCol": 8,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 10265,
    "SubLengths": [4, 4, 0, 0, 0],
    "SubmittedBy": "wilbert",
    "SubmittedDate": "2009-05-05T03:42:18.233",
    "Title": "Green Turn"
  },
  {
    "About": "Left on green, right on green... wait, what?",
    "AllowedCommands": 0,
    "Colors": [
      "GBBBBBBBBBBBBBBG",
      "BRRRRRGBBBBBRBBG",
      "GBRBGRBRRRRRRRRR",
      "RRRRBRBRGBBBBBBG",
      "GBRBGRBRBRRRRRRB",
      "BRRRRRBRBRBRRRRB",
      "GBRBGRBRBRGBBBBG",
      "RRRRBRBRBRRRRRRR",
      "GBRBGRBRGBBBRBBG",
      "BRRRRRBRRRRRRRRB",
      "GBRBGRGBBBBBBBBG",
      "BBBBGRRRRRRRRRRR"
    ],
    "CommentCount": 124,
    "DifficultyVoteCount": 1872,
    "DifficultyVoteSum": 3398,
    "Disliked": 55,
    "Featured": false,
    "Id": 425,
    "Items": [
      "*..............*",
      ".#####*........*",
      "*...*#.#########",
      "####.#.#*......*",
      "*...*#.#.######.",
      ".#####.#.#.####.",
      "*...*#.#.#*....*",
      "####.#.#.#######",
      "*...*#.#*......*",
      ".#####.########.",
      "*...*#*........*",
      "*...*###########"
    ],
    "Liked": 1594,
    "RobotCol": 10,
    "RobotDir": 1,
    "RobotRow": 5,
    "Solutions": 10881,
    "SubLengths": [4, 4, 0, 0, 0],
    "SubmittedBy": "azrael",
    "SubmittedDate": "2009-05-03T07:01:48.797",
    "Title": "Flip Flop"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "BRRRBRRRRRRRRRRR",
      "BRRRBRRRRRRRBRRR",
      "BRRRBRRRRRRRBRRR",
      "BRRRBRRRRRRRBRBR",
      "BRBRBRRRBRRRBRBR",
      "BRBRBRRRBRBRBRBR",
      "BBBRBRRRBRBRBRBR",
      "BBBRBBRRBRBRBBBR",
      "BBBRBBRRBBBRBBBR",
      "BBBRBBRRBBBBBBBB",
      "BBBBBBBBBBBBBBBB"
    ],
    "CommentCount": 370,
    "DifficultyVoteCount": 1459,
    "DifficultyVoteSum": 5035,
    "Disliked": 30,
    "Featured": false,
    "Id": 656,
    "Items": [
      "*###*###########",
      "*###*#######*###",
      "*###*#######*###",
      "*###*#######*#*#",
      "*#*#*###*###*#*#",
      "*#*#*###*#*#*#*#",
      "***#*###*#*#*#*#",
      "***#**##*#*#***#",
      "***#**##***#***#",
      "***#**##********",
      "****************",
      ".***************"
    ],
    "Liked": 1308,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 9993,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "axelbrz",
    "SubmittedDate": "2009-06-04T01:10:55.017",
    "Title": "Limit Your Stack!"
  },
  {
    "AllowedCommands": 7,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRBRBRBRRRRR",
      "RRRRRRRBGBRRRRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRBRBRRRRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 80,
    "DifficultyVoteCount": 1858,
    "DifficultyVoteSum": 3551,
    "Disliked": 50,
    "Featured": false,
    "Id": 285,
    "Items": [
      "################",
      "######*...*#####",
      "######.#*#.#####",
      "######*...*#####",
      "########.#######",
      "#######.#.######",
      "########.#######",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 1580,
    "RobotCol": 8,
    "RobotDir": 3,
    "RobotRow": 4,
    "Solutions": 10386,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "deepak",
    "SubmittedDate": "2009-04-04T17:27:25.907",
    "Title": "The Skull"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRGRBBRBRBBRBGBR",
      "RRBRGRRRRRRRRRBR",
      "RRRRBRBBBBBGBRRR",
      "RRBRRRGRRRRRRRBR",
      "RRRRBRBRBGBRBRRR",
      "RRBRRRBRRRGRRRBR",
      "RRRRBRBGBBBRBRRR",
      "RRBRRRRRRRRRGRBR",
      "RRRRBGBRBRBRBRBR",
      "RRBRRRRRRRRRRRGR",
      "RRBGBBRBRBRBRBBR"
    ],
    "CommentCount": 82,
    "DifficultyVoteCount": 1709,
    "DifficultyVoteSum": 3591,
    "Disliked": 62,
    "Featured": false,
    "Id": 159,
    "Items": [
      "#**#############",
      "##*#..*.*..*.*.#",
      "##.#*#########.#",
      "##*#.#.....*.#*#",
      "##.#*#*#####*#.#",
      "##*#.#.#.*.#.#*#",
      "##.#*#.###*#*#.#",
      "##*#.#.*...#.#*#",
      "##.#*#######*#.#",
      "##*#.*.*.*.*.#.#",
      "##.###########*#",
      "##.*..*.*.*.*..#"
    ],
    "Liked": 1407,
    "RobotCol": 8,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 9009,
    "SubLengths": [4, 5, 0, 0, 0],
    "SubmittedBy": "patatino",
    "SubmittedDate": "2009-03-19T11:59:58.407",
    "Title": "Labyrinth"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRGGGRRRRRRR",
      "RRRRRGGRGGRRRRRR",
      "RRRRRGRBRGRRRRRR",
      "RRRRRGGRGGRRRRRR",
      "RRRRRRGGGRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 66,
    "DifficultyVoteCount": 1512,
    "DifficultyVoteSum": 3126,
    "Disliked": 134,
    "Featured": false,
    "Id": 416,
    "Items": [
      "################",
      "################",
      "################",
      "######***#######",
      "#####*.*.*######",
      "#####**.**######",
      "#####*.*.*######",
      "######***#######",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 1131,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 8386,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "rafaelromao",
    "SubmittedDate": "2009-05-02T13:35:40.64",
    "Title": "Red Cross"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "BBBBBBBBBBBBBBBB",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 125,
    "DifficultyVoteCount": 1430,
    "DifficultyVoteSum": 3633,
    "Disliked": 45,
    "Featured": false,
    "Id": 615,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "...............*",
      "################",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 1230,
    "RobotCol": 6,
    "RobotDir": 2,
    "RobotRow": 5,
    "Solutions": 11331,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "markbyers",
    "SubmittedDate": "2009-05-30T11:20:46.36",
    "Title": "Turn Around"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRBBBBBRRRRRRBBB",
      "RRRRRRRBRRRRBRRR",
      "RRRRRRRBRRRRBRRR",
      "RRRRRRRGBBBBGRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 66,
    "DifficultyVoteCount": 1176,
    "DifficultyVoteSum": 3094,
    "Disliked": 38,
    "Featured": false,
    "Id": 616,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "##......####...*",
      "#######.####.###",
      "#######.####.###",
      "#######......###",
      "################",
      "################",
      "################"
    ],
    "Liked": 946,
    "RobotCol": 5,
    "RobotDir": 2,
    "RobotRow": 5,
    "Solutions": 7181,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "markbyers",
    "SubmittedDate": "2009-05-30T11:26:42.47",
    "Title": "Turn Around 2"
  },
  {
    "About": "check all corners...",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRGGRGGRGGRRR",
      "RRRRRGGGGGGGGBRR",
      "RRRRRRRRRRRRRGGR",
      "RRRRRRBRRRBRRGGR",
      "RRRRRRRBBBRRRGRR",
      "RRRRRRRRRRRRRGGR",
      "RRRRRRRRRRRRRGGR",
      "RRRRRRRRRRRRRGRR",
      "RRRRRRRBRBRRRGGR",
      "RRRRRRRRBRRRRGGR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 62,
    "DifficultyVoteCount": 1259,
    "DifficultyVoteSum": 3036,
    "Disliked": 97,
    "Featured": false,
    "Id": 514,
    "Items": [
      "################",
      "#####**#**#**###",
      "#####.********##",
      "#############**#",
      "####.#.###.#.**#",
      "#####.......#*##",
      "#######.#.###**#",
      "#####.#####.#**#",
      "#####.#####.#*##",
      "######..#..##**#",
      "#######...###**#",
      "########.####*##"
    ],
    "Liked": 898,
    "RobotCol": 5,
    "RobotDir": 0,
    "RobotRow": 2,
    "Solutions": 7423,
    "SubLengths": [6, 5, 2, 5, 0],
    "SubmittedBy": "evilknievel",
    "SubmittedDate": "2009-05-13T10:21:51.827",
    "Title": "Evil Knievel's Evil Cave"
  },
  {
    "About": "Very Simple..",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RGRRRRRRRRRRRRGR",
      "RRRRRBRBBRBRRRRR",
      "RRBRBBRBBRBRBBRR",
      "RRBRBBRRRRBRRRRR",
      "RRBRBBRBBRBRBBRR",
      "RRBRBBRBBRBRRRRR",
      "RRBBBBBBBBBBBBRR",
      "RRRRRRRRRRRRRRRR",
      "RRBBBBBBBBBBBBRR",
      "RGRRRRRRRRRRRRGR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 55,
    "DifficultyVoteCount": 1591,
    "DifficultyVoteSum": 2920,
    "Disliked": 133,
    "Featured": false,
    "Id": 206,
    "Items": [
      "################",
      "#*............*#",
      "#.###.#..#.###.#",
      "#..#..#..#.#...#",
      "#..#..####.###.#",
      "#..#..#..#.#...#",
      "#..#..#..#.###.#",
      "#..............#",
      "#.############.#",
      "#..............#",
      "#*............*#",
      "################"
    ],
    "Liked": 1126,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 7,
    "Solutions": 7988,
    "SubLengths": [3, 2, 3, 0, 0],
    "SubmittedBy": "mrthe",
    "SubmittedDate": "2009-03-27T17:56:48.877",
    "Title": "The"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRBBBBBBBBBRR",
      "RRRRBBRRBBBRRBBR",
      "RRRRBRRRRBRRRRBR",
      "RRRRBRRRRGRRRRBR",
      "RRRRBBRRRRRRRBBR",
      "RRRRBBBRRRRRBBBR",
      "RRRRRRBBRRRBBRRR",
      "RRRRRRRBBRBBRRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 105,
    "DifficultyVoteCount": 1405,
    "DifficultyVoteSum": 3278,
    "Disliked": 54,
    "Featured": false,
    "Id": 247,
    "Items": [
      "#####.........##",
      "####..**...**..#",
      "####.*##*.*##*.#",
      "####.*###*###*.#",
      "####..*#####*..#",
      "####...*###*...#",
      "######..*#*..###",
      "#######..*..####",
      "#######.....####",
      "################",
      "################",
      "################"
    ],
    "Liked": 1213,
    "RobotCol": 9,
    "RobotDir": 3,
    "RobotRow": 8,
    "Solutions": 7845,
    "SubLengths": [6, 3, 0, 0, 0],
    "SubmittedBy": "anthares",
    "SubmittedDate": "2009-03-31T17:00:32.577",
    "Title": "Make Love, Not War"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RBBBBBBBBBBBBBBB",
      "RGRRRRRRRRRRRRRG",
      "RGBGGGGGGGGGGGBG",
      "RGBRBBBBBBBBBRBG",
      "RGBRGRRRRRRRGRBG",
      "RGBRGBGGGGGBGRBG",
      "RGBRBBBBBBRBGRBG",
      "RGBGGGGGGGGBGRBG",
      "RGRRRRRRRRRRGRBG",
      "RBBBBBBBBBBBBRBG",
      "GGGGGGGGGGGGGGBG",
      "RRRRRRRRRRRRRRRG"
    ],
    "CommentCount": 70,
    "DifficultyVoteCount": 1544,
    "DifficultyVoteSum": 2913,
    "Disliked": 91,
    "Featured": false,
    "Id": 225,
    "Items": [
      "****************",
      "****************",
      "****************",
      "****************",
      "****************",
      "****************",
      "****************",
      "****************",
      "****************",
      "****************",
      "****************",
      ".***************"
    ],
    "Liked": 1232,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 8145,
    "SubLengths": [4, 4, 4, 0, 0],
    "SubmittedBy": "mathew995",
    "SubmittedDate": "2009-03-28T19:22:06.907",
    "Title": "Timer"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRGGRBBBGRBRR",
      "RRRRRBRRRRRGRBRR",
      "RRRRRBRGGBBRRBRR",
      "RRRRRBRBGBBBRBRR",
      "RRRRRBRRBBBBRBRR",
      "RRRRRBRGBBBBRBRR",
      "RRRRRRGGBBBGRBRR",
      "RRRRRGRRRRRRRBRR",
      "RRRRRGBBBBBRGGRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 79,
    "DifficultyVoteCount": 1272,
    "DifficultyVoteSum": 2769,
    "Disliked": 73,
    "Featured": false,
    "Id": 224,
    "Items": [
      "################",
      "################",
      "#####.......#*##",
      "#####.#####.#.##",
      "#####.#*....#.##",
      "#####.#.....#.##",
      "#####.#.....#.##",
      "#####.#.....#.##",
      "#####......*#.##",
      "#####.#######.##",
      "#####.........##",
      "################"
    ],
    "Liked": 942,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 6839,
    "SubLengths": [6, 4, 0, 0, 0],
    "SubmittedBy": "surgency",
    "SubmittedDate": "2009-03-28T18:50:39.343",
    "Title": "Evil Green"
  },
  {
    "About": "An easy puzzle for once ;-)",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RGBBBBBBBBBBBBGR",
      "RBGBBBBBBBBBBGBR",
      "RBBGBBBBBBBBGBBR",
      "RBBBGBBBBBBGBBBR",
      "RBBBBGBBBBGBBBBR",
      "RBBBBRBBBBGBBBBR",
      "RBBBRBBBBBBGBBBR",
      "RBBRBBBBBBBBGBBR",
      "RBRBBBBBBBBBBGBR",
      "RRBBBBBBBBBBBBGR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 47,
    "DifficultyVoteCount": 1309,
    "DifficultyVoteSum": 2767,
    "Disliked": 38,
    "Featured": false,
    "Id": 204,
    "Items": [
      "################",
      "#**************#",
      "#**************#",
      "#**************#",
      "#**************#",
      "#**************#",
      "#**************#",
      "#**************#",
      "#**************#",
      "#**************#",
      "#.*************#",
      "################"
    ],
    "Liked": 1055,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 6843,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-27T06:26:52.827",
    "Title": "Let the Lines Guide You"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBGR",
      "RRRRRRRRRRRRRRRB",
      "BBBBBBBBBBBBGRRB",
      "RRRRRRRRRRRRRBRB",
      "BRRBBBBBBBRGRBRB",
      "BRGRRRRRRRRBRBRB",
      "BRBRBRRRRRRGRBRB",
      "BRBRBGBBBBBRRBRB",
      "BRBRRRRRRRRRRGRB",
      "BRGRBBBBBBBBBRRB",
      "BRRRRRRRRRRRRRRG",
      "RGBBBBBBBBBBBBBR"
    ],
    "CommentCount": 84,
    "DifficultyVoteCount": 1061,
    "DifficultyVoteSum": 2884,
    "Disliked": 13,
    "Featured": false,
    "Id": 532,
    "Items": [
      "......*.........",
      "###############.",
      ".....*........#.",
      ".############.#.",
      ".#....*.....#*#.",
      ".#.########*#.#*",
      "*#*#*######.#.#.",
      ".#.#....*...#.#.",
      ".#.##########.#.",
      ".#.......*....#.",
      ".##############.",
      "........*......."
    ],
    "Liked": 881,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 5344,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "rilo",
    "SubmittedDate": "2009-05-16T08:44:39.89",
    "Title": "Spirelli"
  },
  {
    "About": "maybe it's a red herring",
    "AllowedCommands": 0,
    "Colors": [
      "GBBBBBBBBBBBBRRR",
      "GBBBBBBBBBBBRRRR",
      "GBBBBBBBBBBRRRRR",
      "GBBBBBBBBBRRRRRR",
      "GBBBBBBBBRRRRRRR",
      "GBBBBBBBRRRRRRRR",
      "GBBBBBBRRRRRRRRR",
      "GBBBBBRRRRRRRRRR",
      "GBBBBRRRRRRRRRRR",
      "GBBBRRRRRRRRRRRR",
      "GBBRRRRRRRRRRRRR",
      "GBRRRRRRRRRRRRRR"
    ],
    "CommentCount": 69,
    "DifficultyVoteCount": 1154,
    "DifficultyVoteSum": 2849,
    "Disliked": 50,
    "Featured": false,
    "Id": 154,
    "Items": [
      "*************.##",
      "************####",
      "***********.####",
      "**********.#####",
      "*********.######",
      "********.#######",
      "*******.########",
      "******.#########",
      "*****.##########",
      "****.###########",
      "***.############",
      "*..#############"
    ],
    "Liked": 907,
    "RobotCol": 1,
    "RobotDir": 2,
    "RobotRow": 11,
    "Solutions": 5775,
    "SubLengths": [5, 6, 0, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-03-19T00:59:01.657",
    "Title": "Missing Red Tile"
  },
  {
    "About": "O_o",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRBBBBBBBBBRRRRR",
      "RRBRBRBRBRBRRRRR",
      "RRBBRBBBRBBRRRRR",
      "RRBRBRBRBRBRRRRR",
      "RRBBBBGBBBBRRRRR",
      "RRBRBRBRBRBRRRRR",
      "RRBBRBBBRBBRRRRR",
      "RRBRBRBRBRBRRRRR",
      "RRBBBBBBBBBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 75,
    "DifficultyVoteCount": 1070,
    "DifficultyVoteSum": 2490,
    "Disliked": 50,
    "Featured": false,
    "Id": 548,
    "Items": [
      "################",
      "##*********#####",
      "##*#*#*#*#*#####",
      "##*********#####",
      "##*#*#*#*#*#####",
      "##****.****#####",
      "##*#*#*#*#*#####",
      "##*********#####",
      "##*#*#*#*#*#####",
      "##*********#####",
      "################",
      "################"
    ],
    "Liked": 809,
    "RobotCol": 6,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 5996,
    "SubLengths": [6, 1, 0, 0, 0],
    "SubmittedBy": "ammonzing",
    "SubmittedDate": "2009-05-17T21:54:44.36",
    "Title": "Cube Extreme"
  },
  {
    "About": "See if you can solve this puzzle using the paint commands",
    "AllowedCommands": 7,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRRBRRBRRR",
      "RRRRRRBRRBRRBRBR",
      "RRRRRBRBRBRRBRBR",
      "RRBBBBBRRRBBBBBR",
      "RRRRRBRRRRRRBRRR",
      "RRRRRBBBBBBBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 66,
    "DifficultyVoteCount": 985,
    "DifficultyVoteSum": 2414,
    "Disliked": 20,
    "Featured": false,
    "Id": 280,
    "Items": [
      "################",
      "################",
      "#########*..*###",
      "#########.##.###",
      "#####*.*#.##.#*#",
      "#####.#.#.##.#.#",
      "##.*.*.*#*..*.*#",
      "#####.######.###",
      "#####*......*###",
      "################",
      "################",
      "################"
    ],
    "Liked": 834,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 4963,
    "SubLengths": [5, 3, 3, 0, 0],
    "SubmittedBy": "evilpettingzoo",
    "SubmittedDate": "2009-04-03T16:30:58.267",
    "Title": "Fun with Paint"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRBBBBRRRRRRR",
      "RRRRRBRRBRRRRRRR",
      "RRRRRBRBBRRRRRRR",
      "RRRRRBRRRRRRRRRR",
      "RRRRRBBBBBRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 66,
    "DifficultyVoteCount": 1180,
    "DifficultyVoteSum": 2884,
    "Disliked": 50,
    "Featured": false,
    "Id": 84,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "#####....#######",
      "#####.##.#######",
      "#####.#..#######",
      "#####.##########",
      "#####....*######",
      "################",
      "################",
      "################"
    ],
    "Liked": 1037,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 4849,
    "SubLengths": [5, 2, 2, 2, 2],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-02T05:16:54.5",
    "Title": "Simple Spiral"
  },
  {
    "AllowedCommands": 2,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRBBBRBBBRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 43,
    "DifficultyVoteCount": 901,
    "DifficultyVoteSum": 2083,
    "Disliked": 45,
    "Featured": false,
    "Id": 499,
    "Items": [
      "################",
      "################",
      "################",
      "#######*########",
      "#######.########",
      "#######.########",
      "####*.....*#####",
      "#######.########",
      "#######.########",
      "#######*########",
      "################",
      "################"
    ],
    "Liked": 671,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 4456,
    "SubLengths": [4, 3, 0, 0, 0],
    "SubmittedBy": "rainault",
    "SubmittedDate": "2009-05-11T21:17:46.407",
    "Title": "Feeling a Little Cross"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRBBBBBBBBBRRR",
      "RRRRBRRRRRRRBRRR",
      "RRRRBRRRRRRRBRRR",
      "RRRRBRRRRRRRBRRR",
      "RRRRBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 67,
    "DifficultyVoteCount": 1115,
    "DifficultyVoteSum": 2611,
    "Disliked": 50,
    "Featured": true,
    "Id": 42,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "####*********###",
      "####*#######*###",
      "####*#######*###",
      "####*#######*###",
      "####.********###",
      "################",
      "################",
      "################"
    ],
    "Liked": 931,
    "RobotCol": 4,
    "RobotDir": 0,
    "RobotRow": 8,
    "Solutions": 5426,
    "SubLengths": [5, 2, 2, 2, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-02-24T14:39:03.593",
    "Title": "The Powers"
  },
  {
    "About": "\"Walkin' the mile, walkin' the mile...\"",
    "AllowedCommands": 0,
    "Colors": [
      "GBBBBBBBBBBBRRRR",
      "BGBBBBBBBBBRRRRR",
      "BBGBBBBBBBBRRRRR",
      "BBBGBBBBBBBRRRRR",
      "BBBBGBBBBBBRRRRR",
      "BBBBBGBBBBBRRRRR",
      "BBBBBGBBBBBRRRRR",
      "BBBBBBGBBBBRRRRR",
      "BBBBBBBGBBBRRRRR",
      "BBBBBBBBGBBRRRRR",
      "BBBBBBBBBGBRRRRR",
      "BBBBBBBBBBGRRRRR"
    ],
    "CommentCount": 66,
    "DifficultyVoteCount": 832,
    "DifficultyVoteSum": 2423,
    "Disliked": 8,
    "Featured": false,
    "Id": 555,
    "Items": [
      "***********.####",
      "**.......**#####",
      "*.*.....*.*#####",
      "*..*...*..*#####",
      "*...*.*...*#####",
      "*....*....*#####",
      "*....*....*#####",
      "*...*.*...*#####",
      "*..*...*..*#####",
      "*.*.....*.*#####",
      "**.......**#####",
      "***********#####"
    ],
    "Liked": 665,
    "RobotCol": 11,
    "RobotDir": 2,
    "RobotRow": 0,
    "Solutions": 3683,
    "SubLengths": [4, 4, 0, 0, 0],
    "SubmittedBy": "rilo",
    "SubmittedDate": "2009-05-19T19:42:48.75",
    "Title": "The Green Mile"
  },
  {
    "About": "A simple puzzle for understanding the call stack",
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBGBBBBBBBR",
      "RRRRRRRRRRRRRRBR",
      "BBBBBBRBBBBBBRBR",
      "BRRRRRRRRRRRBRBR",
      "BRBBBBGBBBBRBRBR",
      "BRBRRRRRRRRRGRRR",
      "RRGRBBBBBBBRBRBR",
      "BRBRRRRRRRRRBRBR",
      "BRBBBBBRBBBBBRBR",
      "BRRRRRRRRRRRRRBR",
      "BBBBBBBGBBBBBBBR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 62,
    "DifficultyVoteCount": 913,
    "DifficultyVoteSum": 2376,
    "Disliked": 15,
    "Featured": false,
    "Id": 536,
    "Items": [
      "...............#",
      "##############.#",
      ".............#.#",
      ".###########.#.#",
      ".#.........#.#.#",
      ".#.#######.#.#.#",
      ".#.#*......#.#.#",
      ".#.#########.#.#",
      ".#...........#.#",
      ".#############.#",
      "...............#",
      "################"
    ],
    "Liked": 744,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 5081,
    "SubLengths": [3, 3, 0, 0, 0],
    "SubmittedBy": "rilo",
    "SubmittedDate": "2009-05-16T11:44:35.843",
    "Title": "Recursed"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBGRRRRRRR",
      "RRRRRRRBBRRRRRRR"
    ],
    "CommentCount": 42,
    "DifficultyVoteCount": 594,
    "DifficultyVoteSum": 1708,
    "Disliked": 32,
    "Featured": false,
    "Id": 472,
    "Items": [
      "#######**#######",
      "#######.*#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######",
      "#######**#######"
    ],
    "Liked": 418,
    "RobotCol": 7,
    "RobotDir": 1,
    "RobotRow": 1,
    "Solutions": 2994,
    "SubLengths": [2, 2, 2, 3, 3],
    "SubmittedBy": "rafaelromao",
    "SubmittedDate": "2009-05-07T20:34:47.483",
    "Title": "Elevator"
  },
  {
    "About": "may look deceptively hard.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RBGBRBRBRRRRRRRR",
      "RGBRRGBRBRBRRRRR",
      "RRRRRRRRGBRBRRRB",
      "RRRRRRRRRRRRBGBG",
      "RRRRRRRRRRRRGBRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 45,
    "DifficultyVoteCount": 736,
    "DifficultyVoteSum": 1762,
    "Disliked": 16,
    "Featured": false,
    "Id": 320,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "###*.###########",
      "..*.*.*.########",
      "#*.##*.*.*.#####",
      "########*.*.##*.",
      "###########*.*.*",
      "############*.##",
      "################",
      "################"
    ],
    "Liked": 596,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 3612,
    "SubLengths": [3, 4, 4, 0, 0],
    "SubmittedBy": "wallacoloo",
    "SubmittedDate": "2009-04-07T19:45:48.733",
    "Title": "Up or Down?"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRBBBRRRR",
      "RRRRRRRRBRRBRRRR",
      "RRRRRRRBRRRBRRRR",
      "RRRRRRBRRRRBRRRR",
      "RRRRRBRRRRRBRRRR",
      "RRRRBRRRRRRBRRRR",
      "RRRBBRRRRRRBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 35,
    "DifficultyVoteCount": 673,
    "DifficultyVoteSum": 1901,
    "Disliked": 9,
    "Featured": false,
    "Id": 511,
    "Items": [
      "################",
      "################",
      "################",
      "#########...####",
      "########....####",
      "#######...#.####",
      "######...##.####",
      "#####...###.####",
      "####...####.####",
      "###...#####*####",
      "################",
      "################"
    ],
    "Liked": 560,
    "RobotCol": 5,
    "RobotDir": 3,
    "RobotRow": 9,
    "Solutions": 3711,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "ajji",
    "SubmittedDate": "2009-05-12T20:41:32.297",
    "Title": "Up Then Down"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RBBBRBBBBBRBBBBR",
      "RRRRRRRRRRRRRRRB",
      "RBRBBBBRBBBBBRRB",
      "BRRRRRRRRRRRRBRB",
      "BRRBRRBBBBBRRRRB",
      "BRBRRRRRRRRRRRRR",
      "BRRRBRRRRRRRRBRB",
      "BRBRRBRBBRBRRBRB",
      "BRRRRRRRRRRRRBRB",
      "RRRBBBBRRBBBBRRB",
      "RRRRRRRRRRRRRRRR",
      "RBBBBRBBBBBRBBBR"
    ],
    "CommentCount": 69,
    "DifficultyVoteCount": 651,
    "DifficultyVoteSum": 1781,
    "Disliked": 10,
    "Featured": false,
    "Id": 444,
    "Items": [
      "................",
      "###############.",
      "..............#.",
      ".############.#.",
      ".#..........#.#.",
      ".#.########.#.#.",
      ".#.#*######.#.#.",
      ".#.#........#.#.",
      ".#.##########.#.",
      ".#............#.",
      ".##############.",
      "................"
    ],
    "Liked": 550,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 2898,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "markbyers",
    "SubmittedDate": "2009-05-04T14:29:50.173",
    "Title": "Not Yet... Not Yet..."
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRGGGRRRRRRRR",
      "RRRRRGRGRRRRRRRR",
      "RRRRRGRBGGGRRRRR",
      "RRRGGBRRRRGRRRRR",
      "RRRGRRRRRRBGGGRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 38,
    "DifficultyVoteCount": 774,
    "DifficultyVoteSum": 1806,
    "Disliked": 34,
    "Featured": false,
    "Id": 104,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "#####...########",
      "#####.#.########",
      "#####.#....#####",
      "###...####.#####",
      "###.######...*##",
      "###.############"
    ],
    "Liked": 593,
    "RobotCol": 3,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 3901,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "jacob_c",
    "SubmittedDate": "2009-03-07T14:51:46.203",
    "Title": "Coroutines"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRGGGRGGGRRR",
      "RRRGGGRRRGRRRGRR",
      "RRGRRRRBRRRBRGRR",
      "RRGRBBBBBBBBRGRR",
      "RRGRBBBBBBBBRGRR",
      "RRGRRRRRRRBBRGRR",
      "RRRGGGGGGRBBRGRR",
      "RRRRBBBRRRRBRGRR",
      "RRBBRRRBRRRBRGRR",
      "RRBRRGRBBBBBRGRR",
      "RRBRGGRRRRRRRGRR",
      "RRBRGGGGGGGGGRRR"
    ],
    "CommentCount": 77,
    "DifficultyVoteCount": 880,
    "DifficultyVoteSum": 2041,
    "Disliked": 38,
    "Featured": true,
    "Id": 17,
    "Items": [
      "######...#...###",
      "###...***.***.##",
      "##.****.***.*.##",
      "##.*........*.##",
      "##.*........*.##",
      "##.*******..*.##",
      "###......*..*.##",
      "####...####.*.##",
      "##..***.###.*.##",
      "##.**.*.....*.##",
      "##.*..*******.##",
      "##...........###"
    ],
    "Liked": 731,
    "RobotCol": 3,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 4886,
    "SubLengths": [10, 10, 10, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2008-12-15T03:32:00.627",
    "Title": "The Star-studded Path I"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RGRRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 53,
    "DifficultyVoteCount": 873,
    "DifficultyVoteSum": 2074,
    "Disliked": 38,
    "Featured": false,
    "Id": 106,
    "Items": [
      "################",
      "################",
      "################",
      "#..............#",
      "#############**#",
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 690,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 3,
    "Solutions": 4168,
    "SubLengths": [4, 0, 0, 0, 0],
    "SubmittedBy": "jacob_c",
    "SubmittedDate": "2009-03-08T15:57:02.517",
    "Title": "Zipline 2"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRBBRRRRRRRR",
      "RRRRRBBRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRBRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 27,
    "DifficultyVoteCount": 605,
    "DifficultyVoteSum": 1587,
    "Disliked": 30,
    "Featured": false,
    "Id": 227,
    "Items": [
      "################",
      "################",
      "##########*#####",
      "##########.#####",
      "#########..#####",
      "########..######",
      "#######.*#######",
      "######..########",
      "#####..#########",
      "#####.##########",
      "#####*##########",
      "################"
    ],
    "Liked": 430,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 3164,
    "SubLengths": [10, 4, 0, 0, 0],
    "SubmittedBy": "wallacoloo",
    "SubmittedDate": "2009-03-28T20:50:30.923",
    "Title": "Propeller"
  },
  {
    "About": " ",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRBBBBBBRRRR",
      "RRRRRRBRBBRBRRRR",
      "RRRRRRBBBBBBRRRR",
      "RRRRRRBBBBBBRRRR",
      "RRRRRRBRBBRBRRRR",
      "RRRRRRBBBBBBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 33,
    "DifficultyVoteCount": 807,
    "DifficultyVoteSum": 1860,
    "Disliked": 42,
    "Featured": true,
    "Id": 25,
    "Items": [
      "################",
      "################",
      "################",
      "######******####",
      "######*#**#*####",
      "######**.***####",
      "######******####",
      "######*#**#*####",
      "######******####",
      "################",
      "################",
      "################"
    ],
    "Liked": 647,
    "RobotCol": 8,
    "RobotDir": 3,
    "RobotRow": 5,
    "Solutions": 3530,
    "SubLengths": [4, 4, 4, 0, 0],
    "SubmittedBy": { "-i:nil": "true" },
    "SubmittedDate": "2008-12-15T03:57:50.657",
    "Title": "A Window"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRGRRRR",
      "RRRRRRRRRBGBRRRR",
      "RRRRRRRRBGBRRRRR",
      "RRRRRRRBGBRRRRRR",
      "RRRRRRBGBRRRRRRR",
      "RRRRRBGBRRRRRRRR",
      "RRRRBGBRRRRRRRRR",
      "RRRBGBRRRRRRRRRR",
      "RRRGRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 30,
    "DifficultyVoteCount": 617,
    "DifficultyVoteSum": 1549,
    "Disliked": 24,
    "Featured": false,
    "Id": 365,
    "Items": [
      "################",
      "##########*.####",
      "#########*.*####",
      "########*.*#####",
      "#######*.*######",
      "######*.*#######",
      "#####*.*########",
      "####*.*#########",
      "###..*##########",
      "###.*###########",
      "################",
      "################"
    ],
    "Liked": 460,
    "RobotCol": 3,
    "RobotDir": 0,
    "RobotRow": 8,
    "Solutions": 3297,
    "SubLengths": [3, 3, 3, 3, 0],
    "SubmittedBy": "rafaelromao",
    "SubmittedDate": "2009-04-20T18:46:43.14",
    "Title": "Upstairs, Downstairs"
  },
  {
    "About": "Can you take both?",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBGGGGGGGGGGGGBR",
      "RGRRRRRRRRRRRRGR",
      "RGRRRRRRRRRRRRGR",
      "RGRRRRRRRRRRRRGR",
      "RGRRRRRRRRRRRRGR",
      "RGRRRRRRRRRRRRGR",
      "RGRRRRRRRRRRRRGR",
      "RGRRRRRRRRRRRRGR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 38,
    "DifficultyVoteCount": 567,
    "DifficultyVoteSum": 1513,
    "Disliked": 16,
    "Featured": false,
    "Id": 380,
    "Items": [
      "################",
      "################",
      "#..............#",
      "#.############.#",
      "#.############.#",
      "#.############.#",
      "#.############.#",
      "#.############.#",
      "#.############.#",
      "#*############*#",
      "################",
      "################"
    ],
    "Liked": 440,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 2,
    "Solutions": 2616,
    "SubLengths": [4, 4, 4, 0, 0],
    "SubmittedBy": "cybermg",
    "SubmittedDate": "2009-04-25T06:34:55.907",
    "Title": "Two Paths"
  },
  {
    "About": "Recursion is like a spring - it stores energy",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBBBBBBGRBGRBGRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 47,
    "DifficultyVoteCount": 771,
    "DifficultyVoteSum": 1789,
    "Disliked": 36,
    "Featured": false,
    "Id": 142,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "*******.*******#",
      "################",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 602,
    "RobotCol": 7,
    "RobotDir": 2,
    "RobotRow": 5,
    "Solutions": 4954,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "sam0737",
    "SubmittedDate": "2009-03-15T14:05:49.28",
    "Title": "Single Recursion 1"
  },
  {
    "About": "stand hut!",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "GBGBGBGBGBGBGBGG",
      "BRRRRRRRRRRRRRRG",
      "BRGBGBGBGBGBGBGG",
      "BRRRRRRRRRRRRRRG",
      "GBGBGBGBGBGBGBGG",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 40,
    "DifficultyVoteCount": 463,
    "DifficultyVoteSum": 1279,
    "Disliked": 23,
    "Featured": false,
    "Id": 503,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "................",
      ".#*#*#*#*#*#*#*.",
      ".*..............",
      ".#*#*#*#*#*#*#*.",
      "................",
      "################",
      "################",
      "################"
    ],
    "Liked": 354,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 2139,
    "SubLengths": [3, 3, 0, 0, 0],
    "SubmittedBy": "ammonzing",
    "SubmittedDate": "2009-05-12T02:41:12.72",
    "Title": "Marine March"
  },
  {
    "About": "it's easy",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRBBBBBGBBBBBRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR"
    ],
    "CommentCount": 36,
    "DifficultyVoteCount": 697,
    "DifficultyVoteSum": 1573,
    "Disliked": 22,
    "Featured": false,
    "Id": 171,
    "Items": [
      "################",
      "#######*########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "##*.........*###",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########"
    ],
    "Liked": 526,
    "RobotCol": 7,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 3288,
    "SubLengths": [4, 4, 0, 0, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-20T19:41:44.377",
    "Title": "1-2-3-4-5"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRBBBBBBBBBBBRRR",
      "RBRRRRRRRRRRBRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR"
    ],
    "CommentCount": 56,
    "DifficultyVoteCount": 825,
    "DifficultyVoteSum": 1888,
    "Disliked": 41,
    "Featured": false,
    "Id": 330,
    "Items": [
      "#............###",
      "#.##########*###",
      "#.##############",
      "#.##############",
      "#.##############",
      "#.##############",
      "#.##############",
      "#.##############",
      "#.##############",
      "#.##############",
      "#.##############",
      "#.##############"
    ],
    "Liked": 615,
    "RobotCol": 1,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 7335,
    "SubLengths": [3, 4, 0, 0, 0],
    "SubmittedBy": "abhishikt",
    "SubmittedDate": "2009-04-09T07:33:13.813",
    "Title": "Learning Stack"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RBBBBBBBBBBBRRRR",
      "BRRRRRRRRRRBRRRR",
      "BRRBBBRRRRRBRRRR",
      "BRBRRBRRRRRBRRRR",
      "BRBRRBRRRRRGBBBB",
      "BRBBBBBBGRRRRRRB",
      "BRRRRBRRBRRRRRRB",
      "BRRRRBRRBRRRRRRB",
      "BRRRRBRRBRRRRRRB",
      "BRRRRBRRBRRRRRRB",
      "BRRRRBRRBRRRRRRB",
      "BRRRRBRRBBBBBBBR"
    ],
    "CommentCount": 29,
    "DifficultyVoteCount": 728,
    "DifficultyVoteSum": 1723,
    "Disliked": 13,
    "Featured": false,
    "Id": 333,
    "Items": [
      "************####",
      "*##########*####",
      "*#****#####*####",
      "*#*##*#####*####",
      "*#*##*#####*****",
      "*#*******######*",
      "*####*##*######*",
      "*####*##*######*",
      "*####*##*######*",
      "*####*##*######*",
      "*####*##*######*",
      ".####*##********"
    ],
    "Liked": 597,
    "RobotCol": 0,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 3929,
    "SubLengths": [3, 5, 0, 0, 0],
    "SubmittedBy": "abhishikt",
    "SubmittedDate": "2009-04-10T08:12:27.937",
    "Title": "Learning Stack 2"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRBRRRRRRRBRRR",
      "RRRRBRRRRRRRBRRR",
      "RRRBBBRRRRRBBBRR",
      "RRRBBBRRRRRBBBRR",
      "RRRBBBRRRRRBBBRR",
      "RRBBBBBBRBBBBBBR",
      "RRBBBBBBBBBBBBBR",
      "RRBBBBBBBBBBBBBR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 28,
    "DifficultyVoteCount": 679,
    "DifficultyVoteSum": 1591,
    "Disliked": 40,
    "Featured": true,
    "Id": 37,
    "Items": [
      "################",
      "####*#######*###",
      "####.#######.###",
      "###*.*#####*.*##",
      "###...#####...##",
      "###...#####...##",
      "##*...**#**...*#",
      "##......*......#",
      "##.............#",
      "##.............#",
      "################",
      "################"
    ],
    "Liked": 482,
    "RobotCol": 2,
    "RobotDir": 3,
    "RobotRow": 9,
    "Solutions": 3289,
    "SubLengths": [10, 10, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-02-21T14:36:33.077",
    "Title": "On the Edge"
  },
  {
    "AllowedCommands": 7,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRGGRRRRRRR",
      "RRRRRRRGBBGRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRRRRBRRRRR",
      "RRRRRRRBGRGBBGRR",
      "RRRRRRRRBRRRRBRR",
      "RRRRRRRRGBBGRBRR",
      "RRRRRRRRRRRBRBRR",
      "RRRRRRRRRRRGBGRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 37,
    "DifficultyVoteCount": 420,
    "DifficultyVoteSum": 1293,
    "Disliked": 8,
    "Featured": false,
    "Id": 389,
    "Items": [
      "################",
      "#######**#######",
      "#######**..#####",
      "##########.#####",
      "##########.#####",
      "##########.#####",
      "#######..#....##",
      "########.####.##",
      "########....#.##",
      "###########.#.##",
      "###########...##",
      "################"
    ],
    "Liked": 356,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 2373,
    "SubLengths": [4, 3, 0, 0, 0],
    "SubmittedBy": "shahbawany",
    "SubmittedDate": "2009-04-28T22:52:48.453",
    "Title": "Parity Snake"
  },
  {
    "About": "\"Turn right when you get up there.\"",
    "AllowedCommands": 0,
    "Colors": [
      "RGBBBBBBBBBBBGRB",
      "RBRRRRRRRRRRRBRB",
      "RGBBBBBBBGRRRBRB",
      "RRRRRRRRRBRRRBRB",
      "RRRRBRRRRBRRRBRB",
      "RRRBRBRGBBBGRBRB",
      "RRRBRBRBRBRBRBRB",
      "RRBBBRRBRRBGRBRB",
      "RBRBRRRBRRRRRBRB",
      "RBRRBBBGRRBBBRRB",
      "RBRRRRRRRBRRRRRB",
      "RGRRRRRRRRBBBBBR"
    ],
    "CommentCount": 46,
    "DifficultyVoteCount": 563,
    "DifficultyVoteSum": 1513,
    "Disliked": 6,
    "Featured": false,
    "Id": 309,
    "Items": [
      "#*************#*",
      "#*###########*#*",
      "#*********###*#*",
      "#########*###*#*",
      "###***###*###*#*",
      "###*#*#*****#*#*",
      "###*#*#*#*#*#*#*",
      "#*****#*#***#*#*",
      "#*#*###*#####*#*",
      "#*#*****#*****#*",
      "#*#######*#####*",
      "#.#######*******"
    ],
    "Liked": 468,
    "RobotCol": 1,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 2630,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-06T11:33:14.733",
    "Title": "Early Warning"
  },
  {
    "About": "paint your way",
    "AllowedCommands": 7,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRBBBBBBBBBBBBBR",
      "RRBRRRBRRRBRRRBR",
      "RRBRRRBRRRBRRRBR",
      "RRBRRRBRRRBRRRBR",
      "RRBBBBBBBBBBBBBR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 27,
    "DifficultyVoteCount": 410,
    "DifficultyVoteSum": 1129,
    "Disliked": 9,
    "Featured": false,
    "Id": 410,
    "Items": [
      "################",
      "################",
      "##*.*.*.*.*.*.*#",
      "##.###.###.###.#",
      "##*###*###*###*#",
      "##.###.###.###.#",
      "##*.*.*.*...*.*#",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 302,
    "RobotCol": 10,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 2071,
    "SubLengths": [8, 0, 0, 0, 0],
    "SubmittedBy": "matush",
    "SubmittedDate": "2009-05-01T16:58:39.077",
    "Title": "Black Windows"
  },
  {
    "About": "This puzzle is dedicated to those that enjoy bad puns.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RBRRRBBBRBRRRBRR",
      "RBBRBBBBBBBRBBBR",
      "RBBBBBRBBBBBBBBR",
      "RBBBBRRBBBRRBBBR",
      "RBBRRRRRBRRRRBRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 26,
    "DifficultyVoteCount": 403,
    "DifficultyVoteSum": 1333,
    "Disliked": 8,
    "Featured": true,
    "Id": 14,
    "Items": [
      "################",
      "#####...########",
      "#..#..*....#...#",
      "#....*.*.*...*.#",
      "#.*.*.*........#",
      "#.........**.*.#",
      "#..**..........#",
      "#.*.....*....*.#",
      "#...###...##...#",
      "#######.*.######",
      "#######...######",
      "################"
    ],
    "Liked": 347,
    "RobotCol": 1,
    "RobotDir": 3,
    "RobotRow": 8,
    "Solutions": 2305,
    "SubLengths": [10, 2, 2, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2008-12-15T03:32:00.047",
    "Title": "Can You Reach the Stars?"
  },
  {
    "About": "Boost on green, left on red and ...",
    "AllowedCommands": 0,
    "Colors": [
      "BRRRRRRRRRRRRRRR",
      "BRRGBBBGBBBGBBBR",
      "BRBRRRRRRRRRRRRB",
      "BRBRRGBBBGBBBRRG",
      "GRBRBRRRRRRRRBRB",
      "BRGRBRBGBBBRRGRB",
      "BRBRBRRRRRRBRBRB",
      "BRBRBBBBGBBRRBRG",
      "GRBRRRRRRRRRRBRB",
      "BRBBBBGBBBGBBRRB",
      "BRRRRRRRRRRRRRRB",
      "RBBBGBBBGBBBGBBR"
    ],
    "CommentCount": 25,
    "DifficultyVoteCount": 292,
    "DifficultyVoteSum": 977,
    "Disliked": 7,
    "Featured": false,
    "Id": 584,
    "Items": [
      ".###############",
      ".#..............",
      ".#.############.",
      ".#.#..........#.",
      ".#.#.########.#.",
      ".#.#.#*.....#.#.",
      ".#.#.######.#.#.",
      ".#.#........#.#.",
      ".#.##########.#.",
      ".#............#.",
      ".##############.",
      "................"
    ],
    "Liked": 233,
    "RobotCol": 0,
    "RobotDir": 1,
    "RobotRow": 0,
    "Solutions": 1456,
    "SubLengths": [4, 3, 2, 0, 0],
    "SubmittedBy": "rafaelromao",
    "SubmittedDate": "2009-05-24T07:39:08.14",
    "Title": "Boost Spiral"
  },
  {
    "About": "There's a method to the madness",
    "AllowedCommands": 0,
    "Colors": [
      "RRGGGGGRRRRBBRRR",
      "RGRRRRRGRRBRRBRR",
      "RGRRRRRGRRBRRBRR",
      "RGRGGGGRRRBRRBRR",
      "RGRRRRRRRRGRRBRR",
      "RGRRRRRRRRGRRBRR",
      "RRGGGGGGGGRRRBRR",
      "RRRRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRBRR",
      "RBBBBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 35,
    "DifficultyVoteCount": 497,
    "DifficultyVoteSum": 1354,
    "Disliked": 12,
    "Featured": false,
    "Id": 398,
    "Items": [
      "#.......##....##",
      "#.#####.##.##.##",
      "#.#####.##.##.##",
      "#.#*....##.##.##",
      "#.########.##.##",
      "#.########.##.##",
      "#..........##.##",
      "#############.##",
      "#############.##",
      "#.............##",
      "################",
      "################"
    ],
    "Liked": 409,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 9,
    "Solutions": 2616,
    "SubLengths": [7, 0, 0, 0, 0],
    "SubmittedBy": "cybermg",
    "SubmittedDate": "2009-04-29T03:33:31.47",
    "Title": "Jekyll and Hyde"
  },
  {
    "About": "Left on green... right on green?",
    "AllowedCommands": 0,
    "Colors": [
      "BRRRRRBRRRRRBRRR",
      "BRRBRRRBGRGBRRGB",
      "RRBRBRRRBRBRRRBR",
      "RBGRGBRRBRBRGBRR",
      "BRRRRRBRBRBRBRRR",
      "RBGRGBRRRBRRGBRR",
      "RRBRBRRRRRRRRRBR",
      "RBGRGBRRRBRRGBRR",
      "BRRRRRBRBRBRBRRR",
      "RBGRGBRRBRBRGBBR",
      "RRBRBRRRBRBRRRRB",
      "BBGRGBBBGRGBBBBR"
    ],
    "CommentCount": 23,
    "DifficultyVoteCount": 344,
    "DifficultyVoteSum": 1021,
    "Disliked": 8,
    "Featured": false,
    "Id": 439,
    "Items": [
      ".#####.#####.###",
      ".#...#...#...#.*",
      "##.#.###.#.###.#",
      "...#...#.#.#...#",
      ".#####.#.#.#.###",
      "...#...#...#...#",
      "##.#.#########.#",
      "...#...#...#...#",
      ".#####.#.#.#.###",
      "...#...#.#.#....",
      "##.#.###.#.####.",
      "...#.....#......"
    ],
    "Liked": 293,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 1564,
    "SubLengths": [8, 4, 0, 0, 0],
    "SubmittedBy": "coolchrisrm",
    "SubmittedDate": "2009-05-04T02:15:36.22",
    "Title": " Easy Peezy"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRBRRRRRRRRRRRRR",
      "RRBRRRRRRRRRRBRR",
      "RRBRGRRRRRRRRBRR",
      "RRBRGRRRRRRGRBRR",
      "RRBRGRBRRRRGRBRR",
      "RRBRGRBRRBRGRBRR",
      "RRBRGRBRRBRGRBRR",
      "RRBRGRBRRRRGRBRR",
      "RRBRGRRRRRRGRBRR",
      "RRBRGRRRRRRRRBRR",
      "RRBRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 27,
    "DifficultyVoteCount": 598,
    "DifficultyVoteSum": 1439,
    "Disliked": 19,
    "Featured": true,
    "Id": 20,
    "Items": [
      "##............##",
      "##.##########.##",
      "##.#........#.##",
      "##.#.######.#.##",
      "##.#.#....#.#.##",
      "##.#.#.##.#.#.##",
      "##.#.#.#..#.#.##",
      "##.#.#.####.#.##",
      "##.#.#......#.##",
      "##.#.########.##",
      "##*#..........##",
      "################"
    ],
    "Liked": 513,
    "RobotCol": 8,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 3332,
    "SubLengths": [5, 5, 5, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2008-12-15T03:32:01.157",
    "Title": "Spiral to Victory"
  },
  {
    "AllowedCommands": 6,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RRRGBBGRRRRRRRRR",
      "RRRBGBBBBBGRRRRR",
      "RRRBBRBRRRBRRRRR",
      "RRRGBBGBGBBRRRRR",
      "RRRRGBBRBRBRRRRR",
      "RRRRRRGBBBGRRRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRBGRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 30,
    "DifficultyVoteCount": 350,
    "DifficultyVoteSum": 1044,
    "Disliked": 2,
    "Featured": false,
    "Id": 500,
    "Items": [
      "################",
      "######*#########",
      "######.#########",
      "###....#########",
      "###........#####",
      "###..#.###.#####",
      "###........#####",
      "####...#.#.#####",
      "######.....#####",
      "########.#######",
      "#######..#######",
      "################"
    ],
    "Liked": 314,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 1700,
    "SubLengths": [3, 4, 0, 0, 0],
    "SubmittedBy": "rainault",
    "SubmittedDate": "2009-05-11T21:47:08.53",
    "Title": "Movable Paint"
  },
  {
    "About": "Toggle at junctions",
    "AllowedCommands": 7,
    "Colors": [
      "RRGBBGBBGBBGBBRR",
      "RRBBRBRBBBBBRRBR",
      "RRBRRBRRBRRBBRBR",
      "RRGBBRBBRBBRBBGR",
      "RRRRRRRRRRRRRRBR",
      "RRRRRRRRRRRRRRBR",
      "RRGBBRBBRBBRBBRR",
      "RRBBRBRBBBBBRRBR",
      "RRBBRBBRBBRBRBBR",
      "RRGBBGBBGBBGBBRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 36,
    "DifficultyVoteCount": 314,
    "DifficultyVoteSum": 937,
    "Disliked": 3,
    "Featured": false,
    "Id": 401,
    "Items": [
      "##*************#",
      "##*.#*#.*..*##*#",
      "##*##*##*##*.#*#",
      "##*************#",
      "##############*#",
      "##############*#",
      "##*************#",
      "##*.#*#.*..*##*#",
      "##*.#*.#*.#*#.*#",
      "##**.**********#",
      "################",
      "################"
    ],
    "Liked": 283,
    "RobotCol": 4,
    "RobotDir": 0,
    "RobotRow": 9,
    "Solutions": 1437,
    "SubLengths": [6, 4, 0, 0, 0],
    "SubmittedBy": "shahbawany",
    "SubmittedDate": "2009-04-29T19:35:33.157",
    "Title": "Color Changing"
  },
  {
    "About": "... the other recursion !",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRBBBBBBBBRBBRRR",
      "RRRRRRRRRRBRBRRR",
      "RRRRRRRRRRBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 33,
    "DifficultyVoteCount": 754,
    "DifficultyVoteSum": 1620,
    "Disliked": 38,
    "Featured": false,
    "Id": 59,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "##........***###",
      "##########*#*###",
      "##########***###",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 594,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 4046,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "mandark",
    "SubmittedDate": "2009-02-26T11:30:51.437",
    "Title": "Recursion"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RGGGGGRRRRGGGGBB",
      "RBBBBGRRGGBBBBRB",
      "RRRRRBRRGRRRRRRB",
      "GBRRRBBRGRGGGGRB",
      "GBRRRRRGGRGRRRBB",
      "GBRRRRRRRRGRRRRR",
      "GBRRRRRBBRBGGGGG",
      "GBRRRBBGBRBBBBBG",
      "GBRRRBRGBRRRRRRB",
      "RGGGGRRGBRRRRRRB",
      "RRRRRRRGBGGGRRRB",
      "RRRRRRRGGRRRBBBB"
    ],
    "CommentCount": 20,
    "DifficultyVoteCount": 222,
    "DifficultyVoteSum": 685,
    "Disliked": 3,
    "Featured": false,
    "Id": 313,
    "Items": [
      "#.....#.........",
      "#.***.#.*******.",
      "####*.#.*#####*.",
      ".*##*...*#*****.",
      ".*##*****#*.....",
      ".*########*.####",
      ".*##*****#*.....",
      ".*##*...*#*****.",
      ".*##*.#.*#####*.",
      ".****.#.*#####*.",
      "......#.*******.",
      "#######........."
    ],
    "Liked": 175,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 1,
    "Solutions": 837,
    "SubLengths": [5, 5, 5, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-06T17:58:01.267",
    "Title": "Colorful Path"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRBRRRBBBBR",
      "RRRRRRRBRRRBRBRR",
      "RRRRRRRBRRRRRBRR",
      "RRBBBBBBBBBBBBRR",
      "RRRRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 25,
    "DifficultyVoteCount": 502,
    "DifficultyVoteSum": 1314,
    "Disliked": 3,
    "Featured": false,
    "Id": 188,
    "Items": [
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######.*##.####",
      "#######.###.....",
      "#######.###.#.##",
      "#######.#####.##",
      "#.............##",
      "#############.##",
      "#############.##",
      "#############.##"
    ],
    "Liked": 472,
    "RobotCol": 11,
    "RobotDir": 3,
    "RobotRow": 6,
    "Solutions": 2363,
    "SubLengths": [3, 6, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-24T00:04:44.827",
    "Title": "Cut in Half"
  },
  {
    "About": "Upsides and Downsides",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRGRRRR",
      "RRRRRRRRRRRBRRRR",
      "RRRRRRGRRRRBRRRR",
      "RRRRRRBRGRRBGRRR",
      "RRRRRRBRBRRBBRRR",
      "BBRRBRGBGRBGGBRB",
      "RRBBRBRRRBRRRRBR",
      "RRRBRBRRRRRRRRBR",
      "RRRBRRRRRRRRRRBR",
      "RRRRRRRRRRRRRRBR",
      "RRRRRRRRRRRRRRBR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 28,
    "DifficultyVoteCount": 448,
    "DifficultyVoteSum": 1160,
    "Disliked": 14,
    "Featured": false,
    "Id": 151,
    "Items": [
      "###########*####",
      "###########.####",
      "######*####.####",
      "######.#*##.*###",
      "######.#.##..###",
      "...............*",
      "##..#.###.####.#",
      "##*.#.###*####.#",
      "###.#*########.#",
      "###*##########.#",
      "##############.#",
      "##############*#"
    ],
    "Liked": 381,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 2504,
    "SubLengths": [8, 7, 2, 0, 0],
    "SubmittedBy": "recursive",
    "SubmittedDate": "2009-03-17T14:19:00.687",
    "Title": "Graph"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRBRRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRBBBBRRRRRR",
      "RRRRRBBBBBRRRRRR",
      "RRRRRBBBBBRRRRRR",
      "RRRRRBBBBRRRRRRR",
      "RRRRRBBBRRRRRRRR",
      "RRRRRBBRRRRRRRRR",
      "RRRRRBRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 43,
    "DifficultyVoteCount": 479,
    "DifficultyVoteSum": 1142,
    "Disliked": 43,
    "Featured": true,
    "Id": 22,
    "Items": [
      "################",
      "#########*######",
      "########**######",
      "#######***######",
      "######****######",
      "#####*****######",
      "#####*****######",
      "#####****#######",
      "#####***########",
      "#####**#########",
      "#####.##########",
      "################"
    ],
    "Liked": 332,
    "RobotCol": 5,
    "RobotDir": 3,
    "RobotRow": 10,
    "Solutions": 1782,
    "SubLengths": [10, 5, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2008-12-15T03:32:01.5",
    "Title": "Diamond"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RGBBBBBBBBBBBRRR",
      "BRRRRRRRRRRRRGRR",
      "BRRRRRRRRRGRRBRR",
      "BRRGBGBGGRGRRBRR",
      "BRBRRRRRRRBRRBRR",
      "BRBRRBRRRRBRRBRR",
      "BRRRRBRBBGRRRBRR",
      "BBGRRBRRRRBRRBRR",
      "BRRRRBRRRRGRRBRR",
      "BRRRRBRRRRRBGRRR",
      "GRRRRBRRRRRRRRRR",
      "RBBBGRRRRRRRRRRR"
    ],
    "CommentCount": 24,
    "DifficultyVoteCount": 361,
    "DifficultyVoteSum": 986,
    "Disliked": 2,
    "Featured": false,
    "Id": 392,
    "Items": [
      "..............##",
      ".############.##",
      ".#########.##.##",
      ".#.......#.##.##",
      ".#.##.####.##.##",
      ".#.##.####.##.##",
      ".#.##.#....##.##",
      ".*.##.####.##.##",
      ".####.####.##.##",
      ".####.####....##",
      ".####.##########",
      "......##########"
    ],
    "Liked": 314,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 2197,
    "SubLengths": [4, 3, 5, 0, 0],
    "SubmittedBy": "shahbawany",
    "SubmittedDate": "2009-04-28T23:36:38.577",
    "Title": "2-Bit Instructions"
  },
  {
    "AllowedCommands": 2,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RBGGGGGGGGGGGGBR",
      "RGRRRRRRRRRRRRGR",
      "RBGGGRRRGGGGGGBR",
      "RRRRRGRGRRRRRRRR",
      "BBBBBBBBBBBBBBRR",
      "GRGRRGRGRRGRGRGR",
      "GRGRRGRGRRGRGRGR",
      "GRGRRGRGRRGRGRGR",
      "GRRGGRRRGGRRRGRR",
      "GRRRRRRRRRRRRRRR",
      "BGGGGGGGGGGGGGGR"
    ],
    "CommentCount": 28,
    "DifficultyVoteCount": 344,
    "DifficultyVoteSum": 938,
    "Disliked": 6,
    "Featured": false,
    "Id": 193,
    "Items": [
      "################",
      "#*............*#",
      "#.############.#",
      "#*...*#*......*#",
      "#####.#.########",
      "..*.......*.*.*#",
      ".#.##.#.##.#.#.#",
      ".#.##.#.##.#.#.#",
      ".#.##.#.##.#.#.#",
      ".#....#*..*#*.*#",
      ".###############",
      "*.............*#"
    ],
    "Liked": 312,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 1466,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-25T16:40:47.86",
    "Title": "Fix the Path"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRBRBRRRRR",
      "RRRRRRRRBRBRRRRR",
      "RRBRRRBBGBGBBRRR",
      "RRBRRRRRBRBRRRRR",
      "BBGBBRBBGBBRBRRR",
      "RRBRBRBRBRBRBRRR",
      "BBGBGBGBGBGBGBBR",
      "RRBRBRBRBRBRBRRR",
      "BBGBBRBBGBBRBRRR",
      "RRBRRRRRBRRRRRRR",
      "RRBRRRBBGBBRRRRR"
    ],
    "CommentCount": 44,
    "DifficultyVoteCount": 415,
    "DifficultyVoteSum": 1072,
    "Disliked": 13,
    "Featured": false,
    "Id": 88,
    "Items": [
      "################",
      "########*#*#####",
      "########.#.#####",
      "##*###*.....*###",
      "##.#####.#.#####",
      "*...*#*...*#*###",
      "##.#.#.#.#.#.###",
      "*.............*#",
      "##.#.#.#.#.#.###",
      "*...*#*...*#*###",
      "##.#####.#######",
      "##*###*...*#####"
    ],
    "Liked": 361,
    "RobotCol": 8,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 2171,
    "SubLengths": [5, 5, 10, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-03T20:30:22.203",
    "Title": "Incomplete Grid"
  },
  {
    "About": "A themed descent into madness.",
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBR",
      "BBBBBBBRBBBBBBBR",
      "BBBRRBBBBBRRBBBR",
      "BBRRBBRBRBBRRBBR",
      "RRRRBBRRRBBRRRBR",
      "BRRRRRRRRRRRRRBR",
      "BRRRRRRRRRRRRRBR",
      "BRRRRRRRRRRRRRBR",
      "BRRBBRBRBRBBRRRR",
      "BBRRBBBRBBBRRBBR",
      "BBBRRBBBBBRRBBBR",
      "BBBRBBBRBBBBBBBR"
    ],
    "CommentCount": 22,
    "DifficultyVoteCount": 353,
    "DifficultyVoteSum": 963,
    "Disliked": 20,
    "Featured": false,
    "Id": 116,
    "Items": [
      "..........*....#",
      "...............#",
      "..*##.....##*..#",
      ".*##..#.#..##*.#",
      ".###..###..###.#",
      ".#############.#",
      ".#############.#",
      ".#############.#",
      ".##..#.#.#..##.#",
      ".*##...#...##*.#",
      "..*##.....##*..#",
      ".......*.......#"
    ],
    "Liked": 274,
    "RobotCol": 7,
    "RobotDir": 2,
    "RobotRow": 1,
    "Solutions": 1782,
    "SubLengths": [5, 5, 4, 0, 0],
    "SubmittedBy": "raijuzero",
    "SubmittedDate": "2009-03-09T21:45:16.423",
    "Title": "I'm Batman"
  },
  {
    "About": "One function should be enough for anybody",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RGRRRRRRGRRRRRRG",
      "GGRGGRGRGGRRGRRG",
      "GGGGGRGGGGRRGRGG",
      "GGGGGGGGGGGRGGGG",
      "GGGGGGGGGGGRGGGG",
      "GGGGGGGGGGGGGGGG",
      "GGGGGGGGGGGGGGGG",
      "GGGGGGGGGGGGGGGG",
      "GGGGGGGGGGGGGGGG"
    ],
    "CommentCount": 23,
    "DifficultyVoteCount": 274,
    "DifficultyVoteSum": 784,
    "Disliked": 7,
    "Featured": false,
    "Id": 470,
    "Items": [
      "################",
      "################",
      "#*######*######*",
      "..#**#*#.*##*##.",
      "..*..#.*..##.#*.",
      ".....*....*#.*..",
      "...........#....",
      "...........*....",
      "................",
      "................",
      "................",
      "................"
    ],
    "Liked": 227,
    "RobotCol": 0,
    "RobotDir": 3,
    "RobotRow": 3,
    "Solutions": 1210,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "fatbuddha",
    "SubmittedDate": "2009-05-07T18:25:47.86",
    "Title": "Jagged Edge"
  },
  {
    "About":
      "What the HECK are those red tiles for? Something about turning left... or not...",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRBBRBBBBBBRR",
      "RRRRRBRBRRRRRBRR",
      "GBBBBRBBRRRBBRBB",
      "RRRRRBRBRRRBRBRB",
      "RRRRRBBBRRRBBBBR",
      "BBBRRBBBRRRRRRRB",
      "BRBRRBRBRRRRRRRB",
      "BBRBBRBBRRRRRBBB",
      "RRBRRBRRRRRRRBRB",
      "RRBRRBBRBBBBBRBB",
      "RRBRRRRRRRRRRBRB",
      "RRGRRRRRRRRRRBBB"
    ],
    "CommentCount": 32,
    "DifficultyVoteCount": 329,
    "DifficultyVoteSum": 924,
    "Disliked": 4,
    "Featured": false,
    "Id": 492,
    "Items": [
      "#####*.*.....*##",
      "#####.#.#####.##",
      "*....*.*###*.*.*",
      "#####.#.###.#.#.",
      "#####*.*###*.*.*",
      "*.*##*.*#######.",
      ".#.##.#.#######.",
      "*.*..*.*#####*.*",
      "##.##.#######.#.",
      "##.##*.*.....*.*",
      "##.##########.#.",
      "##.##########*.*"
    ],
    "Liked": 278,
    "RobotCol": 2,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 1585,
    "SubLengths": [2, 5, 0, 0, 0],
    "SubmittedBy": "rainault",
    "SubmittedDate": "2009-05-11T00:19:52.78",
    "Title": "Recursive Turning"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRGGGGGRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRGGGGGGGRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRGGGGGGGGGRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRGGGGGGGGGGGRRR",
      "RRRRRRRGRRRRRRRR",
      "RGGGGGGGGGGGGGRR",
      "RRRRRRRGRRRRRRRR"
    ],
    "CommentCount": 25,
    "DifficultyVoteCount": 401,
    "DifficultyVoteSum": 1004,
    "Disliked": 10,
    "Featured": false,
    "Id": 110,
    "Items": [
      "#######*########",
      "######*.*#######",
      "####*.....*#####",
      "######*.*#######",
      "###*.......*####",
      "######*.*#######",
      "##*.........*###",
      "######*.*#######",
      "#*...........*##",
      "######*.*#######",
      "*.............*#",
      "######*.*#######"
    ],
    "Liked": 334,
    "RobotCol": 7,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 1820,
    "SubLengths": [6, 5, 0, 0, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-09T09:16:52.86",
    "Title": "I`m Yolko :)"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRBBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRBBBBBBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBBRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 16,
    "DifficultyVoteCount": 301,
    "DifficultyVoteSum": 910,
    "Disliked": 2,
    "Featured": true,
    "Id": 34,
    "Items": [
      "##............##",
      "##.##########.##",
      "##.#........#.##",
      "##.#.######.#.##",
      "##.#.#....#.#.##",
      "##.#.#.##.#.#.##",
      "##.#.#.#..#.#.##",
      "##.#.#.####.#.##",
      "##.#.#......#.##",
      "##.#.########.##",
      "##*#..........##",
      "################"
    ],
    "Liked": 268,
    "RobotCol": 8,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 1605,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-02-21T01:38:54.937",
    "Title": "Don't Fall Off the Spiral"
  },
  {
    "About": "Are very uncomfortable.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRBBBBBRRRRRR",
      "RRRRRBRRRBRRRRRR",
      "RRRRRBRRRBRRRRRR",
      "RRBBBGRRRBRRRRRR",
      "RRBRRBBBBBRRRRRR",
      "RRBRRBRRRRRRRRRR",
      "RRBBBBRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 24,
    "DifficultyVoteCount": 246,
    "DifficultyVoteSum": 737,
    "Disliked": 4,
    "Featured": false,
    "Id": 628,
    "Items": [
      "################",
      "################",
      "################",
      "#####*****######",
      "#####*###*######",
      "#####*###*######",
      "##***.###*######",
      "##*##*****######",
      "##*##*##########",
      "##****##########",
      "################",
      "################"
    ],
    "Liked": 219,
    "RobotCol": 5,
    "RobotDir": 3,
    "RobotRow": 6,
    "Solutions": 1146,
    "SubLengths": [6, 3, 0, 0, 0],
    "SubmittedBy": "thenick22",
    "SubmittedDate": "2009-05-31T22:54:45.937",
    "Title": "Handcuffs"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRBR",
      "RGGRBGRBBGRRBRGR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 23,
    "DifficultyVoteCount": 527,
    "DifficultyVoteSum": 1237,
    "Disliked": 33,
    "Featured": false,
    "Id": 61,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "##############*#",
      "#..............#",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 431,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 3069,
    "SubLengths": [8, 0, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-02-26T19:40:16.267",
    "Title": "Red-Green Is the Code"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RGGGGGGGGGGGRRGR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBRRBRRBBBBBBBGR",
      "RBRRBRRRRRRRRRRR",
      "RBRRRRRRRRRRRRRR",
      "RGRRGRBRGRBGGBRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RBBGGBBGGBBRRBRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 17,
    "DifficultyVoteCount": 457,
    "DifficultyVoteSum": 1133,
    "Disliked": 4,
    "Featured": false,
    "Id": 80,
    "Items": [
      "################",
      "#..............#",
      "#.############.#",
      "#.############.#",
      "#.##...........#",
      "#.##*###########",
      "#.##############",
      "#.............##",
      "#############.##",
      "#############.##",
      "#.............##",
      "################"
    ],
    "Liked": 411,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 2277,
    "SubLengths": [3, 3, 3, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-01T05:55:19.047",
    "Title": "RRB, RRG"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRBBBRBRBBBBRRR",
      "RRRBGBBBBBRGBRRR",
      "RRBRBBRBRRBBBBRR",
      "BBBBBBBBRRBBBRBB",
      "BGBBGRBBBBBGBBGB",
      "BRBBBBBBBRBRBBBB",
      "BBRBRBBRBBBBBBRB",
      "RBRBGBBGBBRGBBGB",
      "RBBBBBBBBBBBBBBB",
      "BBRBRBBBRRBBRBRR",
      "BGBRRBGRBBBGBRRR",
      "BBBRRBBBRRBBBRRR"
    ],
    "CommentCount": 31,
    "DifficultyVoteCount": 178,
    "DifficultyVoteSum": 604,
    "Disliked": 1,
    "Featured": false,
    "Id": 558,
    "Items": [
      "###...#*#....###",
      "###.********.###",
      "##.*..#*##..*.##",
      "..*....*##...*..",
      ".*..********..*.",
      ".*..*..*.#.*..*.",
      ".*#.*..*...*..*.",
      "#*#.*..*****..*.",
      "#*.*.........*..",
      ".**.#...##..*.##",
      ".*.##..*****.###",
      "...##...##...###"
    ],
    "Liked": 181,
    "RobotCol": 6,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 1148,
    "SubLengths": [10, 10, 10, 0, 0],
    "SubmittedBy": "willbir",
    "SubmittedDate": "2009-05-20T11:11:22.72",
    "Title": "8 Ways"
  },
  {
    "About": "All tiles should be blue when you finish the level.",
    "AllowedCommands": 5,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RBRRGBRRRRRBBBRR",
      "BRBRBRBRRRBRRRBR",
      "RBBBBBRRRRBRRRBR",
      "RRBRBRRRRRBRRRBR",
      "RRBRGBBBBBGBBBRR",
      "RRBRBRRRRRBRRRRR",
      "RRBRBRRRRRBRRRRR",
      "RRBRBRRRRRBRRRRR",
      "GBRBGBBBBBGRRRRR",
      "BRRRBRRRRRBRRRRR",
      "RBBBRRRRRRBRRRRR"
    ],
    "CommentCount": 23,
    "DifficultyVoteCount": 173,
    "DifficultyVoteSum": 581,
    "Disliked": 5,
    "Featured": false,
    "Id": 526,
    "Items": [
      "################",
      "*.*#*.*###*...*#",
      ".#.#.#.###.###.#",
      "*.....*###.###.#",
      "##.#.#####.###.#",
      "##.#*.....*...*#",
      "##.#.#####.#####",
      "##.#.#####.#####",
      "##.#.#####.#####",
      "*.*.*.....*#####",
      ".###.#####.#####",
      "*...*#####*#####"
    ],
    "Liked": 158,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 766,
    "SubLengths": [4, 3, 2, 0, 0],
    "SubmittedBy": "rainault",
    "SubmittedDate": "2009-05-15T04:25:57.36",
    "Title": "Bumpin' Around"
  },
  {
    "About": "So close, yet so far",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRGBBBBRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRBRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 24,
    "DifficultyVoteCount": 340,
    "DifficultyVoteSum": 923,
    "Disliked": 20,
    "Featured": false,
    "Id": 132,
    "Items": [
      "################",
      "####....*.######",
      "####.###########",
      "####.###########",
      "####.###########",
      "####.###########",
      "####.###########",
      "####.###########",
      "####.###########",
      "####.###########",
      "####*###########",
      "################"
    ],
    "Liked": 300,
    "RobotCol": 4,
    "RobotDir": 3,
    "RobotRow": 9,
    "Solutions": 2224,
    "SubLengths": [2, 10, 0, 0, 0],
    "SubmittedBy": "recursive",
    "SubmittedDate": "2009-03-12T17:43:21.343",
    "Title": "Split"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRGBBRBBBBRRR",
      "RBBBBBBBRRRRRRRR",
      "RRRGBBBBRBBRRRRR",
      "RBBBBBBBRRRRRRRR",
      "RRRRGBBBRBBBRRRR",
      "RBBBBBBBRRRRRRRR",
      "RRRRRRGBRBBBBBRR",
      "RBBBBBBBRRRRRRRR",
      "RRGBBBBBRBRRRRRR",
      "RBBBBBBBRRRRRRRR",
      "RRRRGBBBRBBBRRRR",
      "RBBBBBBBRRRRRRRR"
    ],
    "CommentCount": 16,
    "DifficultyVoteCount": 192,
    "DifficultyVoteSum": 584,
    "Disliked": 21,
    "Featured": false,
    "Id": 513,
    "Items": [
      ".####....****###",
      "*........#######",
      "*##......**#####",
      "*........#######",
      "*###.....***####",
      "*........#######",
      "*#####...*****##",
      "*........#######",
      "*#.......*######",
      "*........#######",
      "*###.....***####",
      "*........#######"
    ],
    "Liked": 148,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 1026,
    "SubLengths": [10, 10, 5, 5, 10],
    "SubmittedBy": "alvarom",
    "SubmittedDate": "2009-05-13T04:16:48.563",
    "Title": "Mind the Gap"
  },
  {
    "About": "Red means left... no, right... er, left.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRBBGRRRRRRRR",
      "RBBBRRRGBGRRBBGR",
      "BRRRRRRRRBRBRRBR",
      "BRRBBBGRRRRBRRRR",
      "BRBRRRBRBRRBRBRR",
      "GBRRRBRRGBBRRGGR",
      "RRRRBRRRRRRRRRBR",
      "RRBBRRRBBBBBGRBR",
      "RBRRRRBRRRRRBRBR",
      "RGGRRBRRRBGRBRBR",
      "RRBRBRRRBRBRGBRR",
      "BBRRGBBBRRBRRRRR"
    ],
    "CommentCount": 16,
    "DifficultyVoteCount": 337,
    "DifficultyVoteSum": 946,
    "Disliked": 6,
    "Featured": false,
    "Id": 55,
    "Items": [
      "####....########",
      ".....##...#....#",
      ".########.#.##.#",
      ".#.....#..#.#..#",
      ".#.###.#.##.#.##",
      "...#...#....#..#",
      "####.#########.#",
      "#....#.......#.#",
      "#.####.#####.#.#",
      "#..#...#...#.#.#",
      "##.#.###.#.#...#",
      "...#.....#*#####"
    ],
    "Liked": 299,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 1349,
    "SubLengths": [5, 5, 0, 0, 0],
    "SubmittedBy": "stingray",
    "SubmittedDate": "2009-02-26T04:16:55.157",
    "Title": "Zig Zig"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRBBBBRBRRRR",
      "RRRRRRRRRRRBRRRR",
      "RRRRBRBRBBRBRRRR",
      "RRRRRRBRRRRBRRRR",
      "RRRRBRBRRRRBRRRR",
      "RRRRBRBRRBRBRRRR",
      "RRRRBRRRRRRBRRRR",
      "RRRRBBBBBBBBRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 27,
    "DifficultyVoteCount": 250,
    "DifficultyVoteSum": 706,
    "Disliked": 5,
    "Featured": false,
    "Id": 259,
    "Items": [
      "################",
      "################",
      "######......####",
      "######.####.####",
      "####.#.#*.#.####",
      "####.#.##.#.####",
      "####.#.##.#.####",
      "####.#....#.####",
      "####.######.####",
      "####........####",
      "################",
      "################"
    ],
    "Liked": 222,
    "RobotCol": 4,
    "RobotDir": 1,
    "RobotRow": 4,
    "Solutions": 1067,
    "SubLengths": [9, 0, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-04-02T19:07:38.28",
    "Title": "Shortening"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBGBGBBGBGBGBGBB",
      "RRBRBRRBRBRBRBRR",
      "RRGRBRRBRBRBRRRR",
      "RRRRBRRBRBRBRRRR",
      "RGBBRRRBRBRBRRRR",
      "RRRRRGRBRBRBRRRR",
      "RBBRRBRBRBRBRRRR",
      "BRRBRRBRRBRBRRRR",
      "BBBBRBRBRBRBRRRR",
      "BBGBRRBBBRRBRRRR",
      "BRBRRRRGRRRBRRRR",
      "RBBBBBBBBBBRRRRR"
    ],
    "CommentCount": 18,
    "DifficultyVoteCount": 273,
    "DifficultyVoteSum": 793,
    "Disliked": 2,
    "Featured": false,
    "Id": 249,
    "Items": [
      "...............*",
      "##.#.##.#.#.*.*#",
      "##*#.##.#.#.***#",
      "####.##.#.#.####",
      "#*...##.#.#.####",
      "#####*#.#.#.####",
      "....#.#.#.#.####",
      "....#...#.#.####",
      "....#.#.#.#.####",
      "..*.#.....#.####",
      "....###*###.####",
      "............####"
    ],
    "Liked": 240,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 1410,
    "SubLengths": [5, 5, 5, 5, 0],
    "SubmittedBy": "wallacoloo",
    "SubmittedDate": "2009-03-31T19:51:49.593",
    "Title": "Straying From the Path"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBRRBBBRRRRRRR",
      "BBBBBRBBBRRRRRRR",
      "BBBBBRBBBRRRRRRR",
      "RRBBBRBBBBRBBBBR",
      "RRBBBRBBBBBBBBBB",
      "RBBBBRRBBBBBBBBB",
      "RBBBRRRRRBBBRBBB",
      "RBBBRRRRRRRRRBBB",
      "RBBBBBBBRRRRRBBB",
      "RBBBBBBBBBBBBBBB",
      "RRBBBBBBBBBBBBBB",
      "RRRRRRRBBBBBBBBR"
    ],
    "CommentCount": 10,
    "DifficultyVoteCount": 193,
    "DifficultyVoteSum": 581,
    "Disliked": 4,
    "Featured": false,
    "Id": 446,
    "Items": [
      ".....#...#######",
      "..**.#.*.#######",
      "...*.#.*.#######",
      "##.*.#.*........",
      "#..*.#.***.****.",
      "#.**.#...***..*.",
      "#.*..###......*.",
      "#.*.#########.*.",
      "#.*......####.*.",
      "#.******......*.",
      "#......********.",
      "######.........."
    ],
    "Liked": 173,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 1,
    "Solutions": 1133,
    "SubLengths": [10, 5, 5, 5, 5],
    "SubmittedBy": "markbyers",
    "SubmittedDate": "2009-05-04T15:39:52.03",
    "Title": "Warning Signs"
  },
  {
    "About": "The prelude to Both Directions",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "BBBBBBBRBBBBBBBR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 29,
    "DifficultyVoteCount": 268,
    "DifficultyVoteSum": 798,
    "Disliked": 1,
    "Featured": false,
    "Id": 354,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "*.............*#",
      "################",
      "################",
      "################",
      "################",
      "################"
    ],
    "Liked": 251,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 1812,
    "SubLengths": [5, 3, 0, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-18T05:45:04.11",
    "Title": "Both Directions 0"
  },
  {
    "About": "Count red bricks",
    "AllowedCommands": 0,
    "Colors": [
      "RBBGBBBBRBBBBBBB",
      "RRRRRRRRRRRRRRRB",
      "RBRBBBGRBBBBRBRB",
      "RBRRRRRRRRRRRGRB",
      "RBRBRBBBGRRBRBRB",
      "RRRGRBRRRRRGRBRG",
      "RGRBRRRRRRRBRBRR",
      "RBRBRBRBGBBBRBRR",
      "RBRRRRRRRRRRRBRR",
      "RBRRRRRGBBBBBBRR",
      "RRRRRRRRRRRRRRRB",
      "RBRBRBBRBBBGBBBB"
    ],
    "CommentCount": 22,
    "DifficultyVoteCount": 224,
    "DifficultyVoteSum": 679,
    "Disliked": 2,
    "Featured": false,
    "Id": 318,
    "Items": [
      "#...............",
      "#.#############.",
      "#.#...........#.",
      "#.#.#########.#.",
      "#.#.#.......#.#.",
      "#.#.#*#####.#.#.",
      "#.#.#######.#.#.",
      "#.#.........#.#.",
      "#.###########.#.",
      "#.............#.",
      "###############.",
      "#..............."
    ],
    "Liked": 224,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 1352,
    "SubLengths": [10, 10, 10, 0, 0],
    "SubmittedBy": "esef",
    "SubmittedDate": "2009-04-07T07:41:51.077",
    "Title": "Arithmetic"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRBRRRRRBBRBRR",
      "RRRRBBBGBBGBRBRR",
      "BBGBGRRBBBGBBGRR",
      "RRBRBRRBRRRBRBRR",
      "RBBBGBBGRRRGBGBB",
      "RRBRRRRBRRRBRRRR",
      "RRGBBGBBBRRBRRRR",
      "RRBRBGBBBGBBBBRR",
      "RRBRBBRRRBBGGRRR",
      "BBGBGRRRRGBBGBBB",
      "RRRRBRRRRBRRRRRR",
      "RBBBGBBGRBRRRRRR"
    ],
    "CommentCount": 16,
    "DifficultyVoteCount": 129,
    "DifficultyVoteSum": 480,
    "Disliked": 2,
    "Featured": false,
    "Id": 552,
    "Items": [
      "####.#####..#.##",
      "####...****.#.##",
      "...**##*..****##",
      "##.#*##*###.#*##",
      "#...****###***..",
      "##.####.###*####",
      "##****...##*####",
      "##*#.*****.*..##",
      "##*#..###*.**###",
      "..***####****...",
      "####*####.######",
      "#...****#.######"
    ],
    "Liked": 125,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 2,
    "Solutions": 742,
    "SubLengths": [10, 5, 0, 0, 0],
    "SubmittedBy": "markbyers",
    "SubmittedDate": "2009-05-19T16:45:03.797",
    "Title": "Forest Path"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RBBRRRRRRRRRRRRR",
      "BRRBRRRRRBBBBRRR",
      "BRRGBBRRBRRRRBRR",
      "RBGRRRBRBRRRBGBR",
      "RRBRRBGBGRRBRBRB",
      "RRBRBRBRRGBGBRRB",
      "RRRBGBRRRBRBRRRB",
      "RRRRBRRRRBRBRRRB",
      "RBBBGBRRRBRBRRRB",
      "BRRRBRBRRBRRBBBR",
      "RBBBGBRRRBRRRRRR",
      "RRRRRBBBBRRRRRRR"
    ],
    "CommentCount": 18,
    "DifficultyVoteCount": 135,
    "DifficultyVoteSum": 464,
    "Disliked": 1,
    "Featured": false,
    "Id": 567,
    "Items": [
      "...*############",
      ".##.####*....*##",
      ".#*...*#.####.##",
      "*..*##.#.##*...*",
      "##.#*....*#.#.#.",
      "##.#.#.#*....*#.",
      "##*...*##.#.###.",
      "####.####.#.###.",
      "*.....*##.#.###.",
      ".###.#.##.#*...*",
      "*.....*##.######",
      "####*....*######"
    ],
    "Liked": 119,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 875,
    "SubLengths": [5, 5, 5, 5, 0],
    "SubmittedBy": "markbyers",
    "SubmittedDate": "2009-05-21T12:24:44.173",
    "Title": "Linked Rings"
  },
  {
    "About": "Is it simple?",
    "AllowedCommands": 6,
    "Colors": [
      "BRBBBBBBBBBBBBRB",
      "RRRRRRRRRRRRRRRB",
      "BBBBBBBBBBBBRBRB",
      "RRRRRRRRRRRRRBRB",
      "BRBBBBBBBBRBRBRB",
      "BRRRGRRRRRRBRBRB",
      "BRBRBRRRRRRRRBRB",
      "BRBRBRBBBBBBRBRB",
      "BRBRRRRRRRRRRRRB",
      "BRBRBBBBBBBBBBRB",
      "BRRRRRRRRRRRRRRR",
      "BRBBBBBBBBBBBBBB"
    ],
    "CommentCount": 34,
    "DifficultyVoteCount": 189,
    "DifficultyVoteSum": 620,
    "Disliked": 4,
    "Featured": false,
    "Id": 291,
    "Items": [
      "*...............",
      "###############.",
      "..............#.",
      ".############.#.",
      ".#..........#.#.",
      ".#.#*######.#.#.",
      ".#.#.######.#.#.",
      ".#.#........#.#.",
      ".#.##########.#.",
      ".#............#.",
      ".##############.",
      "................"
    ],
    "Liked": 166,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 858,
    "SubLengths": [4, 5, 2, 0, 0],
    "SubmittedBy": "sungjin",
    "SubmittedDate": "2009-04-05T00:17:54.78",
    "Title": "Huh? Part2"
  },
  {
    "About": "Don't count the greens",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRGBBBBBBBBBBGRR",
      "RRBRRRRRRRRRRBRR",
      "RRBRRRRRRRRRRBRR",
      "RRBRRRRRRRRRRBRR",
      "RRBRRRRRRRRRRBRR",
      "RRGBBBBBBBBRRBRR",
      "RRRRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRBRR",
      "RRBBBBBBBBBBBGRR"
    ],
    "CommentCount": 23,
    "DifficultyVoteCount": 165,
    "DifficultyVoteSum": 599,
    "Disliked": 3,
    "Featured": false,
    "Id": 332,
    "Items": [
      "################",
      "################",
      "##............##",
      "##.##########.##",
      "##.##########.##",
      "##.*#########.##",
      "##.#########*.##",
      "##........*##.##",
      "#############.##",
      "#############.##",
      "##**#*###*###.##",
      "#.............##"
    ],
    "Liked": 176,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 988,
    "SubLengths": [3, 10, 6, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-04-09T15:07:12.093",
    "Title": "Power-of-2 Generator"
  },
  {
    "About": "All work and no play...",
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBGGGGGGGGR",
      "RRRRRRRRRRRRRBRR",
      "RRRRRRRRRRRRRBRR",
      "RRRGRRRRRRRRRBRR",
      "RRRGBBBGGGGRRBRR",
      "RRRGRRRRRBRRRBRR",
      "RRRGRRRRRGRRRGRR",
      "RRRBRRRRRGRRRGRR",
      "RRRBRRRRRRRRRGRR",
      "RRRBRRRRRRRRRGRR",
      "RRGGGGGGBBBBBGRR",
      "RRRRRRRRRRRRRGRR"
    ],
    "CommentCount": 16,
    "DifficultyVoteCount": 318,
    "DifficultyVoteSum": 960,
    "Disliked": 9,
    "Featured": false,
    "Id": 87,
    "Items": [
      "...............#",
      "#############.##",
      "#############.##",
      "###.#########.##",
      "###........##.##",
      "###.#####.###.##",
      "###.####*.###.##",
      "###.#####.###.##",
      "###.#########.##",
      "###.#########.##",
      "##............##",
      "#############.##"
    ],
    "Liked": 280,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 1919,
    "SubLengths": [5, 3, 0, 0, 0],
    "SubmittedBy": { "-i:nil": "true" },
    "SubmittedDate": "2009-03-03T08:48:13.657",
    "Title": "Red Run"
  },
  {
    "About": "Read instructions in reversed order, and then carry them out.",
    "AllowedCommands": 0,
    "Colors": [
      "GBRBRRBBRBBRRBGR",
      "RRRRRRRRRRRRRRGR",
      "RRRRRRRRRRRRGGGR",
      "RRRRRRRRRRRRGRRR",
      "RRRRRRRRRRRRGGGR",
      "RRRRRRRRRRRRRRGR",
      "RRRRRRRRGGGRGGGR",
      "RRRRRRRRGRGRGRRR",
      "RRRRRRGGGRGGGRRR",
      "RRRRRRGRRRRRRRRR",
      "RRRRRRGRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 17,
    "DifficultyVoteCount": 198,
    "DifficultyVoteSum": 656,
    "Disliked": 2,
    "Featured": false,
    "Id": 191,
    "Items": [
      "...............#",
      "##############.#",
      "############...#",
      "############.###",
      "############...#",
      "##############.#",
      "########...#...#",
      "########.#.#.###",
      "######...#...###",
      "######.#########",
      "######*#########",
      "################"
    ],
    "Liked": 182,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 1122,
    "SubLengths": [4, 4, 4, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-25T04:00:34.173",
    "Title": "Reversed Instructions"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRBRBGBRRRRRRRR",
      "RRRBRBRGRRRRRRRR",
      "RRRRRBRRRRRBGBRR",
      "RRRGRBRGRRRRRRRR",
      "RRRBRBRBGGGBRRRR",
      "RRRBRBRRRRRRRRRR",
      "BBBBBBBBGRRBRBRR",
      "RRRBRGRRRRRBRBRR",
      "RRRBRBRRGBRGRBRR",
      "RRRBRRRRRRRBGBRR",
      "RRRBRRRRRBRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 14,
    "DifficultyVoteCount": 110,
    "DifficultyVoteSum": 383,
    "Disliked": 1,
    "Featured": false,
    "Id": 597,
    "Items": [
      "###*#*.*########",
      "###.#.#.########",
      "###.#.#.###*.*##",
      "###.#.#.###.#.##",
      "###.#.#*...*#.##",
      "###.#.#######.##",
      "...........*#.##",
      "###.#.#####.#.##",
      "###.#*...*#.#.##",
      "###.#####.#*.*##",
      "###*.....*######",
      "################"
    ],
    "Liked": 113,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 678,
    "SubLengths": [4, 2, 3, 3, 0],
    "SubmittedBy": "chief",
    "SubmittedDate": "2009-05-26T17:32:38.813",
    "Title": "Cumulative Effect"
  },
  {
    "About": "they're different sizes on purpose!",
    "AllowedCommands": 1,
    "Colors": [
      "RRRRRRRRBBBBBBBR",
      "RRRRRRRBBBBBBBRR",
      "RRRRRRRBBBBBBRRR",
      "RRRRRRRBBBBBRRRR",
      "RRRRRRRBBBBRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRGRRRRRRRR",
      "RRRRRRBBRRRRRRRR",
      "RRRRRBBBRRRRRRRR",
      "RRRRBBBBRRRRRRRR",
      "RRRBBBBRRRRRRRRR"
    ],
    "CommentCount": 17,
    "DifficultyVoteCount": 155,
    "DifficultyVoteSum": 518,
    "Disliked": 3,
    "Featured": false,
    "Id": 254,
    "Items": [
      "#######********#",
      "#######*******##",
      "#######******###",
      "#######*****####",
      "#######****#####",
      "#######***######",
      "#######**#######",
      "#######.########",
      "######**########",
      "#####***########",
      "####****########",
      "###*****########"
    ],
    "Liked": 145,
    "RobotCol": 7,
    "RobotDir": 3,
    "RobotRow": 7,
    "Solutions": 956,
    "SubLengths": [10, 5, 5, 5, 0],
    "SubmittedBy": "wallacoloo",
    "SubmittedDate": "2009-04-01T22:33:18.627",
    "Title": "Two Triangles"
  },
  {
    "About": "...can be confusing.",
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRBRRRRRRRRBRRBR",
      "RBRBRRRRRRBRBGRB",
      "RRBRRRRRRRRGRRBR",
      "RRBRRRRRRRRBRRBR",
      "RRBRRBRRRRBRBRBR",
      "RBRBGRBRBBRGBBRB",
      "RRGRRGRRRRBBRRGR",
      "RBRBBRBBBBGRBRBR",
      "RRBRRBRRRRRBRRGR",
      "RRRRRRRRRRRRRBRB",
      "RRRRRRRRRRRRRRBR"
    ],
    "CommentCount": 11,
    "DifficultyVoteCount": 123,
    "DifficultyVoteSum": 419,
    "Disliked": 1,
    "Featured": false,
    "Id": 236,
    "Items": [
      "################",
      "##*########.##.#",
      "#*.*######...*..",
      "##*########*##.#",
      "##.########.##.#",
      "##.##.####...#.#",
      "#...*..#...*....",
      "##*##*####..##*#",
      "#............#.#",
      "##.##.#####.##*#",
      "#############...",
      "##############.#"
    ],
    "Liked": 115,
    "RobotCol": 8,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 794,
    "SubLengths": [10, 5, 5, 0, 0],
    "SubmittedBy": "wallacoloo",
    "SubmittedDate": "2009-03-29T19:34:54.297",
    "Title": "Getting Directions..."
  },
  {
    "About": "Recursion is like a spring - it stores energy",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRGGGGGGGRRR",
      "RRRRRRGRRRRRGRRR",
      "RRRRRRRRRRRRGRRR",
      "RRRBBBRRRRRRGRRR",
      "RRBRRRBRRRRRGRRR",
      "RRBRRRBRRRRRGRRR",
      "RRBRRBRRRRRRGRRR",
      "RRBRRRRRRRRRGRRR",
      "RRGGGGGGGGGGGRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 15,
    "DifficultyVoteCount": 256,
    "DifficultyVoteSum": 832,
    "Disliked": 5,
    "Featured": false,
    "Id": 143,
    "Items": [
      "################",
      "######.......###",
      "######*#####.###",
      "############.###",
      "##.....#####.###",
      "##.###.#####.###",
      "##.###.#####.###",
      "##.##..#####.###",
      "##.#########.###",
      "##...........###",
      "################",
      "################"
    ],
    "Liked": 212,
    "RobotCol": 5,
    "RobotDir": 0,
    "RobotRow": 7,
    "Solutions": 1422,
    "SubLengths": [7, 0, 0, 0, 0],
    "SubmittedBy": "sam0737",
    "SubmittedDate": "2009-03-15T14:38:47.313",
    "Title": "Double Recursion 2"
  },
  {
    "About": "Jump on red",
    "AllowedCommands": 0,
    "Colors": [
      "GGGGGGGGGGGGGGGG",
      "BBBBGBRRRRRRRRBB",
      "BBRBRRRGRGRBBRGB",
      "BBBRRGBBRRRBGBRR",
      "BRBGRBBBRGBRRBRB",
      "BBBBRRBRGRRRRRRR",
      "BBRBRBRRRGRRRRRG",
      "BBRBRRGRRRRRRGRR",
      "GBBBRGGGRGRRRRRR",
      "RBGBRBRBRGRRRRRR",
      "RGRBRGRBRRGGRRRG",
      "RRRGRRRGRRGRRRRG"
    ],
    "CommentCount": 12,
    "DifficultyVoteCount": 134,
    "DifficultyVoteSum": 451,
    "Disliked": 5,
    "Featured": false,
    "Id": 428,
    "Items": [
      ".***************",
      "....*...........",
      "....#.........*.",
      "....#.......*.#.",
      "....#.......#.#.",
      "....#...*...#.#.",
      "....#...#...#.#.",
      "....#...#...#*#.",
      "*...#.*.#...###.",
      "#.*.#.#.#*..###.",
      "#*#.#*#.##.*###.",
      "###*###*##*####*"
    ],
    "Liked": 127,
    "RobotCol": 0,
    "RobotDir": 1,
    "RobotRow": 0,
    "Solutions": 734,
    "SubLengths": [5, 10, 10, 5, 0],
    "SubmittedBy": "markbyers",
    "SubmittedDate": "2009-05-03T10:02:57.233",
    "Title": "String Escaping"
  },
  {
    "About": "Shortest demo for stack-based memory",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRBBBBB",
      "RRRRRRRRRRRBRRRB",
      "RRRRRRRRRRRBRBRB",
      "RRRRRRRRRRRBBBRB",
      "RRRRRRRRRRRRRRRB",
      "GRGRGGRGGGRGGGGB"
    ],
    "CommentCount": 38,
    "DifficultyVoteCount": 305,
    "DifficultyVoteSum": 994,
    "Disliked": 2,
    "Featured": false,
    "Id": 109,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
      "###########.....",
      "###########.###.",
      "###########.#*#.",
      "###########...#.",
      "###############.",
      "................"
    ],
    "Liked": 300,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 2754,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-09T08:32:00.657",
    "Title": "Second Kind of Memory"
  },
  {
    "AllowedCommands": 1,
    "Colors": [
      "BBBBBBBBBBBBBBRR",
      "BRRRRRRRRRRRRBRR",
      "BRRRRRRRRRRRRBRR",
      "BRRRRRRRRRRRRBRR",
      "BRRRRRRRRRRRRBRR",
      "BRRRRRRRBBRRRBRR",
      "BRRRRRRRBBRRRBRR",
      "BRRRRRRRBRRRRBRR",
      "BRRRRRRRBBBBBBRR",
      "BRRRRRRRRRRRRRRR",
      "BRRRRRRRRRRRRRRR",
      "BRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 18,
    "DifficultyVoteCount": 101,
    "DifficultyVoteSum": 353,
    "Disliked": 4,
    "Featured": false,
    "Id": 199,
    "Items": [
      "..............##",
      ".############.##",
      ".############.##",
      ".############.##",
      ".############.##",
      ".#######...##.##",
      ".#######...##.##",
      ".#######.####.##",
      ".#######......##",
      ".###############",
      ".###############",
      "*###############"
    ],
    "Liked": 99,
    "RobotCol": 9,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 740,
    "SubLengths": [10, 5, 5, 5, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-03-26T12:21:06.983",
    "Title": "Fibonacci Spiral"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BRGGGBRBRGGBRRRB",
      "GRRRRRRGRRRRRRRG",
      "GRRRRRRGRRRGRRRR",
      "GRRRRGRGRRRGRRRR",
      "RRRRRGRGRRRGRRRR",
      "BGGGRGRGRRRBRRGB",
      "RRRRRGRRRRRRRRRR",
      "BGGGRBRBGGRRRRRB",
      "RRRRRRRRRRRRRRRG",
      "RRRRRRRRRRRRRRRR",
      "GRRRRRRRRRRRRRRR",
      "BRRRRRRRRRRGGGGB"
    ],
    "CommentCount": 27,
    "DifficultyVoteCount": 195,
    "DifficultyVoteSum": 639,
    "Disliked": 1,
    "Featured": false,
    "Id": 85,
    "Items": [
      "......#.....###.",
      ".####.#.###.###.",
      ".####.#.###.###.",
      ".####.#.###.###.",
      ".####.#.###.###.",
      "...*#.#.###.....",
      "#####.#.########",
      "......#.........",
      ".##############.",
      ".##############.",
      ".##############.",
      "................"
    ],
    "Liked": 199,
    "RobotCol": 15,
    "RobotDir": 1,
    "RobotRow": 0,
    "Solutions": 1349,
    "SubLengths": [5, 5, 5, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-02T16:29:32.86",
    "Title": "Less or More?"
  },
  {
    "About": "Red is left, Green is right",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRGBBGRRRRRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RGBBBBGRGBBBBBBG",
      "RBRRRRRRBRRRRRRB",
      "RBRRRRRRGBBGRRRB",
      "RBRRRRRRRRRGBGRB",
      "RGBBBBBBBGRRRBRB",
      "RRRRRRRRRGBBBGRB",
      "RRRRRRRRRRRRRRRB",
      "BGRRGGRGGGRGRRRB"
    ],
    "CommentCount": 9,
    "DifficultyVoteCount": 113,
    "DifficultyVoteSum": 394,
    "Disliked": 3,
    "Featured": false,
    "Id": 311,
    "Items": [
      "################",
      "################",
      "###****#########",
      "######*#########",
      "#******#********",
      "#*######*######*",
      "#*######****###*",
      "#*#########***#*",
      "#*********###*#*",
      "#########*****#*",
      "###############*",
      ".***************"
    ],
    "Liked": 109,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 689,
    "SubLengths": [5, 5, 5, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-06T12:05:43.203",
    "Title": "Follow Directions II"
  },
  {
    "About": "a little harder than the first",
    "AllowedCommands": 0,
    "Colors": [
      "RBBBRRBRRBBBRBBB",
      "BBBBRBBGBRBRBBBR",
      "BRBBRRBGBGBBRBBR",
      "BRRBRBRRBGBBGRBR",
      "BBRBBRBRRRBRRRRB",
      "BBRBBRRRBRBBRRGR",
      "BBGBGRBRRRBGRBGR",
      "BBGBRBRRGRBRRBRR",
      "GGRBRGBRGRBRRRRB",
      "GRRGRGRRRRGRRGRR",
      "RRRRRRBRRRRRRRRG",
      "RRRRRRGRRRRRRRRG"
    ],
    "CommentCount": 12,
    "DifficultyVoteCount": 113,
    "DifficultyVoteSum": 380,
    "Disliked": 0,
    "Featured": false,
    "Id": 212,
    "Items": [
      "................",
      ".......*........",
      ".......*.*......",
      ".......#.*..*...",
      ".......#.#..#...",
      ".......#.#..#.*.",
      "..*.*..#.#.*#.*.",
      "..*.#..#*#.##.#.",
      "**#.#*.#*#.##.#.",
      "*##*#*.###*##*#.",
      "######.########*",
      "######*########*"
    ],
    "Liked": 109,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 561,
    "SubLengths": [7, 9, 7, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-03-28T01:19:23.843",
    "Title": "Parity Checker II"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRBRRRBRRRBRRR",
      "RRRBBRBRBRBRBRRB",
      "RBRBBRBBBRBRBBRB",
      "RBBBBBBBBRBBBBRB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "RBBBBBBBBRBBBBRB",
      "RBRBBRBBBRBRBBRB",
      "RRRBBRBRBRBRBRRB",
      "RRRRBRRRBRRRBRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 26,
    "DifficultyVoteCount": 193,
    "DifficultyVoteSum": 592,
    "Disliked": 2,
    "Featured": false,
    "Id": 244,
    "Items": [
      "####*###*###*###",
      "###*.#*#.#*#.##*",
      "#*#..#.*.#.#.*#.",
      "#.*..*...#.*..#.",
      "*........*....*.",
      "................",
      "*........*....*.",
      "#....*...#.*..#.",
      "#*#..#.*.#.#.*#.",
      "###*.#*#.#*#.##*",
      "####*###*###*###",
      "################"
    ],
    "Liked": 182,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 895,
    "SubLengths": [8, 6, 6, 0, 0],
    "SubmittedBy": "recursive",
    "SubmittedDate": "2009-03-30T14:36:36.483",
    "Title": "Waveform"
  },
  {
    "About": "Turn left.  Usually.",
    "AllowedCommands": 0,
    "Colors": [
      "GBBBBBBBBBBBBBBG",
      "BRRRRRRRRRRRRRRB",
      "BRGBBBBBBBBBBGRB",
      "BRBRRRRRRRRRRBRB",
      "BRBRRRRRRRRRRBRB",
      "BRBRGBBBBBBGRBRB",
      "BRBRRRRRRRRBRBRB",
      "BRGBBBBBBBBGRBRB",
      "BRRRRRRRRRRRRBRB",
      "GBBBBBBBBBBBBGRB",
      "RRRRRRRRRRRRRRRB",
      "RRRRRBBBBBBBBBBG"
    ],
    "CommentCount": 11,
    "DifficultyVoteCount": 208,
    "DifficultyVoteSum": 648,
    "Disliked": 8,
    "Featured": false,
    "Id": 153,
    "Items": [
      "................",
      ".##############.",
      ".#............#.",
      ".#.##########.#.",
      ".#.#*########.#.",
      ".#.#........#.#.",
      ".#.########.#.#.",
      ".#..........#.#.",
      ".############.#.",
      "..............#.",
      "###############.",
      "#####..........."
    ],
    "Liked": 191,
    "RobotCol": 5,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 1181,
    "SubLengths": [5, 5, 5, 0, 0],
    "SubmittedBy": "recursive",
    "SubmittedDate": "2009-03-18T23:35:44.61",
    "Title": "Wrong Turn"
  },
  {
    "About":
      "The bottom row tells the robot the colors on which it should turn.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RGBBRRRRRRRRRRRR",
      "RRRRGRRRRRRRGRBR",
      "RRRRBRRRRRRRBRRG",
      "RRRRBRRRRRGBBGRB",
      "RRRRBRRRRRGRRRRB",
      "RRRRGRRRRRGRRRRB",
      "GRBRBRRBBBBRBRRG",
      "GRRRGRRRRRBRRGRB",
      "RRRBGRRRRRRGGRRG",
      "RRRRRRRRRRRRRRRG",
      "BGRGRGRRRGGRRGRB"
    ],
    "CommentCount": 9,
    "DifficultyVoteCount": 99,
    "DifficultyVoteSum": 346,
    "Disliked": 0,
    "Featured": false,
    "Id": 305,
    "Items": [
      "################",
      "#****###########",
      "####*#######****",
      "####*#######*##*",
      "####*#####****#*",
      "####*#####*#**#*",
      "####*#####*####*",
      "**************#*",
      "*###*#####*##*#*",
      "*****#####****#*",
      "###############*",
      ".***************"
    ],
    "Liked": 96,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 568,
    "SubLengths": [4, 5, 5, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-06T04:02:23.767",
    "Title": "Follow Directions"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRBBBBBBBBBBRR",
      "RRRBBBBBBBBBBBRR",
      "RRBBBBBBBBBBBBRR",
      "RRBBBBBBBBBBBBRR",
      "RRBBBBBBBBBBBBRR",
      "RRBBBBBBBBBBBBRR",
      "RRBBBBBBBBBBBBRR",
      "RRRBBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 14,
    "DifficultyVoteCount": 122,
    "DifficultyVoteSum": 421,
    "Disliked": 9,
    "Featured": false,
    "Id": 96,
    "Items": [
      "################",
      "####..........##",
      "###.**********.#",
      "##.***********.#",
      "#.************.#",
      "#.************.#",
      "#.************.#",
      "#.***.********.#",
      "#.************.#",
      "##.**********.##",
      "###..........###",
      "################"
    ],
    "Liked": 97,
    "RobotCol": 5,
    "RobotDir": 0,
    "RobotRow": 7,
    "Solutions": 701,
    "SubLengths": [5, 5, 5, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-03-05T14:31:08.203",
    "Title": "Convex Shape"
  },
  {
    "AllowedCommands": 1,
    "Colors": [
      "RRRBBBBBBBBBBBRR",
      "RRRBRRRRRRRRRBRR",
      "RRRBRBBBBBBBRBRR",
      "RRRBRBRRRRRBRBRR",
      "RRRBRBRBBBRBRBRR",
      "RRRBRBRBRBRBRBRR",
      "RRRBRBRRRBRBRBRR",
      "RRRBRBBBBBRBRBRR",
      "RRRBRRRRRRRBRBRR",
      "RRRBBBBBBBBBRBRR",
      "RRRRRRRRRRRRRBRR",
      "RRBBBBBBBBBBBRRR"
    ],
    "CommentCount": 18,
    "DifficultyVoteCount": 148,
    "DifficultyVoteSum": 494,
    "Disliked": 0,
    "Featured": false,
    "Id": 195,
    "Items": [
      "###...........##",
      "###.#########.##",
      "###.#.......#.##",
      "###.#.#####.#.##",
      "###.#.#...#.#.##",
      "###.#.#*#.#.#.##",
      "###.#.###.#.#.##",
      "###.#.....#.#.##",
      "###.#######.#.##",
      "###.........#.##",
      "#############.##",
      "##............##"
    ],
    "Liked": 149,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 965,
    "SubLengths": [7, 4, 4, 0, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-25T17:44:55.407",
    "Title": "Another Speed Control"
  },
  {
    "About": "Variation on \"Reflection\" theme",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRGGGRRBBBRRRRR",
      "RRGGRRGRBBBBRRRR",
      "RGGRGRGRBRBBRRRR",
      "RGRGRRGRBBBBRRRR",
      "RGRRRRGRRRRBRRRR",
      "RRRRRRBBBBBBRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 38,
    "DifficultyVoteCount": 253,
    "DifficultyVoteSum": 855,
    "Disliked": 6,
    "Featured": false,
    "Id": 94,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "##.....#***#####",
      "#....#.#****####",
      "#..#.#.#*#**####",
      "#....#.#****####",
      "#.####.####*####",
      "#.####******####",
      "################"
    ],
    "Liked": 231,
    "RobotCol": 1,
    "RobotDir": 3,
    "RobotRow": 10,
    "Solutions": 1435,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-04T17:32:07.267",
    "Title": "Treasure Hunters"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRGBBBBBBGRRRRR",
      "RRRBRRRRRRBRRRRR",
      "RGBBBBGRRBBBGRRR",
      "RBRRRRBRRRRRBRRR",
      "RBBGRRBBGRRBBGRR",
      "RRRBRRRRBRRRRBRR",
      "RGBBBRRGBRRGBBBR",
      "RBRRRRRBRRRBRRRR",
      "RBRRRBBBRRRBBBBR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 28,
    "DifficultyVoteCount": 126,
    "DifficultyVoteSum": 456,
    "Disliked": 1,
    "Featured": false,
    "Id": 346,
    "Items": [
      "#######.########",
      "#######*########",
      "###********#####",
      "###*######*#####",
      "#******#*****###",
      "#*####*#####*###",
      "****#****#****##",
      "###*####*####*##",
      "#*****#***#*****",
      "#*#####*###*####",
      "***#*****#******",
      "################"
    ],
    "Liked": 131,
    "RobotCol": 7,
    "RobotDir": 1,
    "RobotRow": 0,
    "Solutions": 1117,
    "SubLengths": [10, 10, 10, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-16T03:26:20.813",
    "Title": "Tree II"
  },
  {
    "About": "\"And after that make another right\"",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRBGRGBBBBBGR",
      "RRRRBRBRBRRRRRBR",
      "RRRRBRBRBRRBBBRR",
      "RRBBRRBRBRBRRRRR",
      "RBRRRRBRBRRBBBGR",
      "RBRRBBRRBRRRRRRR",
      "RBRBRRRRBRRBGRRR",
      "RBRRBBBBGRBRBRRR",
      "RBRRRRRRRRBRGBRR",
      "RGBBBBBBBBGRRRBR",
      "RRRRRRRRRRRRRRBR",
      "BBBBBBBBBBBBBBRR"
    ],
    "CommentCount": 11,
    "DifficultyVoteCount": 73,
    "DifficultyVoteSum": 269,
    "Disliked": 0,
    "Featured": false,
    "Id": 310,
    "Items": [
      "####***#*******#",
      "####*#*#*#####*#",
      "####*#*#*#*****#",
      "#****#*#*#*#####",
      "#*####*#*#****.#",
      "#*#****#*#######",
      "#*#*####*#***###",
      "#*#******#*#*###",
      "#*########*#***#",
      "#**********###*#",
      "##############*#",
      "***************#"
    ],
    "Liked": 72,
    "RobotCol": 14,
    "RobotDir": 2,
    "RobotRow": 4,
    "Solutions": 317,
    "SubLengths": [5, 5, 5, 5, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-06T11:47:04.64",
    "Title": "Very Early Warning"
  },
  {
    "About": "Avoid the pits! ... such a great pun ...",
    "AllowedCommands": 0,
    "Colors": [
      "GGGGGGGGGGGGGGGG",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBRBBBBBBB",
      "BBBRBRBBRBBBBRBB",
      "BBBRBRBBBBRBBRBB",
      "BRBBBBRBBBRBRBBB",
      "BRBBRBRBBRBBRBBB",
      "BBBBRBBBBRBBBBRB",
      "BBRBBBBBBBBRBBRB",
      "BBRBBBRBBBBRBBBB",
      "BBBBBBRBBBBBBBBB",
      "BBBBBBBBBBBBBBBB"
    ],
    "CommentCount": 29,
    "DifficultyVoteCount": 119,
    "DifficultyVoteSum": 433,
    "Disliked": 0,
    "Featured": false,
    "Id": 189,
    "Items": [
      "****************",
      "........*.......",
      "...*.*..#....*..",
      "...#.#..*.*..#..",
      ".*.*.**...#.**..",
      ".#..*.#..**.#...",
      ".*..#.*..#..*.*.",
      "..*.*....*.*..#.",
      "..#...*....#..*.",
      "..*...#....*....",
      "......*.........",
      ".***************"
    ],
    "Liked": 125,
    "RobotCol": 0,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 905,
    "SubLengths": [5, 6, 8, 3, 0],
    "SubmittedBy": "recursive",
    "SubmittedDate": "2009-03-24T11:44:04.453",
    "Title": "Cherry Picking"
  },
  {
    "About": "Where did all the leaves go?",
    "AllowedCommands": 2,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "BRRRRRBRRBBBRBBR",
      "RBRBBBRRBRRRBRRB",
      "BRBRRRRRRRRRBRRR",
      "RRBRRRRRRRRRBRRR",
      "RRRBBBBRBBBBRRRR",
      "RRBRRRRBRRRRBRRR",
      "RRBRRRRBRRRRBRRB",
      "BRBRRBRBRBRRBRRB",
      "RBRBBRRBRRBBRBBR",
      "BRRRRBRBRBRRRRRB",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 14,
    "DifficultyVoteCount": 68,
    "DifficultyVoteSum": 268,
    "Disliked": 0,
    "Featured": false,
    "Id": 358,
    "Items": [
      "*#####*#*######*",
      "*#####*#********",
      "*******#*###*##*",
      "*#*###*#*###*##*",
      "*#*#########*###",
      "##***********###",
      "##*####*####*##*",
      "*#*##*#*#*##*##*",
      "*#*##*#*#*##*##*",
      "******#*#*******",
      "*####*#*#*#####*",
      "*####*#.#*#####*"
    ],
    "Liked": 72,
    "RobotCol": 7,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 429,
    "SubLengths": [5, 10, 0, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-18T21:11:20.923",
    "Title": "Tree III"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRGRRRRR",
      "RGRBBBBBBBRRRRRR",
      "RRBRRRRRRRBRRRRR",
      "RRGRRRRGRRBRRRRR",
      "RRRRRRRBRRBRRRRR",
      "RRRRGBBRRRBRRGRR",
      "RRRRRRRBRRBRGRRR",
      "RRRRGRRBRRBRRBRR",
      "RRRRBRRBRRBRRBRR",
      "RRRRBRRBRRBRRBRR",
      "RRBBRBBRBBRBBRGR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 10,
    "DifficultyVoteCount": 119,
    "DifficultyVoteSum": 450,
    "Disliked": 0,
    "Featured": true,
    "Id": 53,
    "Items": [
      "##########*#####",
      "#*.........#####",
      "##.#######.#####",
      "##*####*##.#####",
      "#######.##.#####",
      "####*...##.##*##",
      "#######.##.#*.##",
      "####*##.##.##.##",
      "####.##.##.##.##",
      "####.##.##.##.##",
      "##............*#",
      "################"
    ],
    "Liked": 131,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 819,
    "SubLengths": [5, 5, 5, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-02-25T12:45:07.627",
    "Title": "Branches"
  },
  {
    "About": "Remember... get the star.",
    "AllowedCommands": 1,
    "Colors": [
      "BRBRBRBRBRBRBRBR",
      "BRBRGGBRBRBRBRBR",
      "BRBRBRBRBRBRBRBR",
      "BRBRBRGGBRGGBRBR",
      "BRBRBRBRBRBRBRGG",
      "BRGGBRBRBRBRBRBR",
      "BRBRBRBRGGBRBRBR",
      "BRBRBRBRBRBRGGBR",
      "GGBRBRBRBRBRBRBR",
      "BRBRBRBRBRBRBRBR",
      "BRBRBRBRBRBRBRBR",
      "BRBRBRBRBRBRBRBR"
    ],
    "CommentCount": 15,
    "DifficultyVoteCount": 109,
    "DifficultyVoteSum": 404,
    "Disliked": 1,
    "Featured": false,
    "Id": 192,
    "Items": [
      ".#.#.#.#.#.#.#.#",
      ".#.#...#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#...#...#.#",
      ".#.#.#.#.#.#.#.*",
      ".#...#.#.#.#.#.#",
      ".#.#.#.#...#.#.#",
      ".#.#.#.#.#.#...#",
      "...#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#"
    ],
    "Liked": 113,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 753,
    "SubLengths": [10, 5, 5, 0, 0],
    "SubmittedBy": "recursive",
    "SubmittedDate": "2009-03-25T11:44:22.953",
    "Title": "Bridge Finder"
  },
  {
    "AllowedCommands": 4,
    "Colors": [
      "RRRRRRGGGGGGGGGG",
      "GRGRGRGRRRRRRRRG",
      "GRGRGRGRGGGGGGRG",
      "GRGRGRGRGRRRRGRG",
      "GRGRGRGRGRBBRGRG",
      "GRGRGRGRGRGGRGRG",
      "GRGRGRRRRRRGRGRG",
      "GRGRBGGGGGGBRGRG",
      "GRGRRRRRRRRRRGRG",
      "GRGGGGGGGGGGGGRG",
      "GRRRRRRRRRRRRRRG",
      "GGGGGGGGGGGGGGGG"
    ],
    "CommentCount": 7,
    "DifficultyVoteCount": 75,
    "DifficultyVoteSum": 282,
    "Disliked": 0,
    "Featured": false,
    "Id": 329,
    "Items": [
      "*****#**********",
      "*#*#*#*########*",
      "*#*#*#*#******#*",
      "*#*#*#*#*####*#*",
      "*#*#*#*#*#**#*#*",
      "*#*#*#*#*#.*#*#*",
      "*#*#*######*#*#*",
      "*#*#********#*#*",
      "*#*##########*#*",
      "*#************#*",
      "*##############*",
      "****************"
    ],
    "Liked": 75,
    "RobotCol": 10,
    "RobotDir": 3,
    "RobotRow": 5,
    "Solutions": 490,
    "SubLengths": [4, 10, 10, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-09T05:54:17.577",
    "Title": "Layered Sheets"
  },
  {
    "About": "clear math, no hacker's features :)",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRBBBBBBBBBBRRR",
      "RRRBRRRRRRRRBRRR",
      "RRRBGGGGGGGRBRRR",
      "RRRBGRRRRRGRBRRR",
      "RRRBGRRRRRGRBRRR",
      "RRRBGRRRRRGRBRRR",
      "RRRBGRRRRRGRBRRR",
      "RRRBRRRRRRGRBRRR",
      "RRRGGGGGGGGRBRRR",
      "RRRBBBBBBBBBBRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 20,
    "DifficultyVoteCount": 92,
    "DifficultyVoteSum": 338,
    "Disliked": 0,
    "Featured": false,
    "Id": 97,
    "Items": [
      "################",
      "###*........*###",
      "###.########.###",
      "###.*.....*#.###",
      "###..#####.#.###",
      "###..*..*#.#.###",
      "###...##.#.#.###",
      "###...##.#.#.###",
      "###..*..*#.#.###",
      "###.......*#.###",
      "###.........*###",
      "################"
    ],
    "Liked": 87,
    "RobotCol": 3,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 383,
    "SubLengths": [3, 4, 4, 4, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-05T15:13:05.767",
    "Title": "Smart Lemma"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "GGGBGRGGGRGRGGRR",
      "GGGGGGGGGGGGGGGR",
      "BGGGGGGGGRGGGGGR",
      "GGGGGGGGGGGGGGGR",
      "BGGBGRGGGGGGGGRR",
      "RRRRRRRRRRRBRRRR",
      "BBBBBBBBBBBBBBBR",
      "BBBBBBBBBBBBBBBR",
      "BBBBBBBBBBBBBBBR",
      "BBBBBBBBBBBBBBBR",
      "BBBBBBBBBBBBBBBR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 25,
    "DifficultyVoteCount": 108,
    "DifficultyVoteSum": 405,
    "Disliked": 0,
    "Featured": false,
    "Id": 162,
    "Items": [
      "...............#",
      "...............#",
      "...............#",
      "...............#",
      "...............#",
      "###########.####",
      "****.*****.****#",
      "*..*.*.....*..*#",
      "****.*****.*..*#",
      "...*.*...*.*..*#",
      "****.*****.****#",
      "################"
    ],
    "Liked": 112,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 758,
    "SubLengths": [5, 4, 3, 3, 0],
    "SubmittedBy": "evko",
    "SubmittedDate": "2009-03-19T20:34:32.64",
    "Title": "\"960\" on Blue"
  },
  {
    "About": "Colors and recursion",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRGBBRBBBGR",
      "BRRRBRRBRRRRRRBR",
      "GBGBGRRGBBBBGBGR",
      "BRBRRRRGBRRRBRRR",
      "BRBRRRRRRRRRBRRR",
      "BRGBBBBGBBBBGRRR",
      "BRBRRRRBRRRRBRBR",
      "BRBRBGRBRRRRBRBR",
      "RRBRRBRBRRGBGBGR",
      "RRBRRBRBRRBRRRBR",
      "RRGBBGRBRRGBBBBR",
      "RRRRRRRBRRRRRRRR"
    ],
    "CommentCount": 23,
    "DifficultyVoteCount": 121,
    "DifficultyVoteSum": 454,
    "Disliked": 3,
    "Featured": false,
    "Id": 152,
    "Items": [
      "*###*#*...*....*",
      ".###.##.######.#",
      ".....##........#",
      ".#.#*#*..*##.#*#",
      ".#.#########.###",
      ".#...........#*#",
      ".#.####.####.#.#",
      ".#.*..*.##*#.#.#",
      "*#.##.#.##.....#",
      "##.##.#.##.###.#",
      "#*....#.#*.....*",
      "#####*#.######*#"
    ],
    "Liked": 114,
    "RobotCol": 7,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 800,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-03-18T22:00:09.86",
    "Title": "Tree"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRBRRRRRRRRRRRRR",
      "RBBBRRRRRRRRRRRB",
      "BBBBBRRRRRRRBRBB",
      "BBBBBBRBRRRBBBBB",
      "BBBBBBBBBRBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "RRRGGGGRGGRRRGRR"
    ],
    "CommentCount": 9,
    "DifficultyVoteCount": 110,
    "DifficultyVoteSum": 413,
    "Disliked": 2,
    "Featured": false,
    "Id": 350,
    "Items": [
      "################",
      "################",
      "##*#############",
      "#***###########*",
      ".****#######*#**",
      "******#*###*****",
      "*********#******",
      "****************",
      "****************",
      "****************",
      "****************",
      "****************"
    ],
    "Liked": 111,
    "RobotCol": 0,
    "RobotDir": 1,
    "RobotRow": 4,
    "Solutions": 665,
    "SubLengths": [7, 7, 7, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-16T15:07:52.61",
    "Title": "Plus or Minus One"
  },
  {
    "About": "Only 2 stars to collect; it can't be that hard.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRBBBBBBBBBRR",
      "RRRRBRRRRRRRRRBR",
      "RRRRBRRRBBRRBRBR",
      "RBRRBRRGRRBRRBRR",
      "BRBRRBBRRRBRRRRR",
      "BRRRRRRRRRBRRRRR",
      "RBBBBBBBBBRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 16,
    "DifficultyVoteCount": 106,
    "DifficultyVoteSum": 407,
    "Disliked": 0,
    "Featured": false,
    "Id": 352,
    "Items": [
      "################",
      "################",
      "####...........#",
      "####.#########.#",
      "####.##....#*#.#",
      "...#.##.##.#...#",
      ".#*#....##.#####",
      ".#########.#####",
      "...........#####",
      "################",
      "################",
      "################"
    ],
    "Liked": 104,
    "RobotCol": 7,
    "RobotDir": 3,
    "RobotRow": 5,
    "Solutions": 551,
    "SubLengths": [5, 6, 0, 0, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-17T06:32:37.377",
    "Title": "Both Directions"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRGBBBGRRRRRRRRR",
      "RRGBBBBBGRRRRRRR",
      "RRGRRRRRRRRRRRRR",
      "RRGBGRRRRRRRRRRR",
      "RRGRRRRRRRRRRRRR",
      "RRGBBBBBBBBGRRRR",
      "RRGRRRRRRRRRRRRR",
      "RRGBBBBBBBBBBBBB",
      "RRGBBBBBBBBBBGRR",
      "RRGBBBBBBBGRRRRR",
      "RRGBBBBBBBBBGRRR"
    ],
    "CommentCount": 26,
    "DifficultyVoteCount": 112,
    "DifficultyVoteSum": 408,
    "Disliked": 0,
    "Featured": false,
    "Id": 654,
    "Items": [
      "##*#############",
      "##.****#########",
      "##*******#######",
      "##*#############",
      "##***###########",
      "##*#############",
      "##**********####",
      "##*#############",
      "##**************",
      "##************##",
      "##*********#####",
      "##***********###"
    ],
    "Liked": 124,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 1,
    "Solutions": 815,
    "SubLengths": [5, 5, 5, 5, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-06-04T00:49:38.733",
    "Title": "Linked List"
  },
  {
    "About": "Visit the rows in order of increasing red tiles",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "GBRRRRRRRRRRRRRR",
      "GBBBBBBBBBBRRRRR",
      "GBRRRRRRRRRRRRRR",
      "GBBBBBBBRRRRRRRR",
      "GBBBBRRRRRRRRRRR",
      "GBBBRRRRRRRRRRRR",
      "GBBBBBBRRRRRRRRR",
      "GBBBBBBBBBBBRRRR",
      "GBBRRRRRRRRRRRRR",
      "GBBBBBRRRRRRRRRR",
      "GBBBBBBBBBRRRRRR"
    ],
    "CommentCount": 28,
    "DifficultyVoteCount": 86,
    "DifficultyVoteSum": 349,
    "Disliked": 0,
    "Featured": false,
    "Id": 676,
    "Items": [
      ".###############",
      "****************",
      "***************#",
      "************####",
      "***************#",
      "***********#####",
      "*************###",
      "***************#",
      "************.###",
      "******##########",
      "***********#####",
      "************####"
    ],
    "Liked": 102,
    "RobotCol": 12,
    "RobotDir": 2,
    "RobotRow": 8,
    "Solutions": 618,
    "SubLengths": [5, 5, 5, 5, 5],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-06-05T01:33:49.657",
    "Title": "Linked List II"
  },
  {
    "About": "binary counting without painting",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRGRRRRRRRR",
      "RRRRRRRGGRRRRRRR",
      "RRRRRRRGGGRRRRRR",
      "RRRRRRRGGGRRRGRR",
      "RRRGRRRGGGRRRGGR",
      "RRGGGRRGGGGRRGGR",
      "RGGGGGRGGGGRGGGG",
      "GGGGGGGGGGGGGGGG",
      "BBBBBBBRRRBBBRBB",
      "BBRRRBBRRBRBBBRB",
      "BRBRBRBRBRBBRBRR",
      "GGGGGGGGGGGGGGGG"
    ],
    "CommentCount": 36,
    "DifficultyVoteCount": 79,
    "DifficultyVoteSum": 321,
    "Disliked": 0,
    "Featured": false,
    "Id": 213,
    "Items": [
      "#######*########",
      "#######**#######",
      "#######***######",
      "#######***###*##",
      "###*###***###**#",
      "##***##****##**#",
      "#*****#****#****",
      "****************",
      "................",
      "................",
      "................",
      "................"
    ],
    "Liked": 86,
    "RobotCol": 0,
    "RobotDir": 3,
    "RobotRow": 11,
    "Solutions": 544,
    "SubLengths": [10, 10, 10, 5, 5],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-03-28T04:12:56.627",
    "Title": "Can You Count in Binary?"
  },
  {
    "About": "It's small... and you have the \"Fast\" button",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBRBBRRR",
      "RRRRRRRBBBBBBRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRBBRRR",
      "RRRRRRRBBRRBBRRR",
      "RRRRRRRBBBBBBRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR"
    ],
    "CommentCount": 28,
    "DifficultyVoteCount": 75,
    "DifficultyVoteSum": 314,
    "Disliked": 0,
    "Featured": true,
    "Id": 36,
    "Items": [
      "################",
      "################",
      "################",
      "#######***#**###",
      "#######*******##",
      "#######*******##",
      "#######**##**###",
      "#######**##***##",
      "#######*******##",
      "#######.******##",
      "################",
      "################"
    ],
    "Liked": 80,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 9,
    "Solutions": 459,
    "SubLengths": [10, 5, 0, 0, 0],
    "SubmittedBy": "igoro",
    "SubmittedDate": "2009-02-21T07:23:28.517",
    "Title": "Explore the World"
  },
  {
    "AllowedCommands": 5,
    "Colors": [
      "RGGGGGGGGGGGGGGG",
      "RBRRRGRRRGRRRGRR",
      "RBRRRGRRRGRRRGRR",
      "RBRRGGGRGGGRGGGR",
      "BRRRGGGRGGGRGGGR",
      "BRRRGRRRGRRRGRRR",
      "BRRRGGGRGGGRGGGR",
      "RBRRGGGRGGGRGGGR",
      "BRRRGGGRGGGRGGGR",
      "BRRRGRRRGRRRGRRR",
      "BGRRGGGRGGGRGGGR",
      "RBRRGGGRGGGRGGGR"
    ],
    "CommentCount": 36,
    "DifficultyVoteCount": 91,
    "DifficultyVoteSum": 379,
    "Disliked": 0,
    "Featured": false,
    "Id": 328,
    "Items": [
      "#***************",
      "#*###*###*###*##",
      "#*###*###*###*##",
      "***#***#***#***#",
      "***#***#***#***#",
      "*###*###*###*###",
      "***#***#***#***#",
      "***#***#***#***#",
      "***#***#***#***#",
      "*###*###*###*###",
      "*.*#***#***#***#",
      "***#***#***#***#"
    ],
    "Liked": 109,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 10,
    "Solutions": 839,
    "SubLengths": [4, 10, 5, 3, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-09T04:16:23.157",
    "Title": "Replication Engine"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRGGGRRRRR",
      "RRRRRRRRGRGRRRRR",
      "RRRRRRRRGRGRGGGR",
      "RRRRRRRRGRGRGRGR",
      "GGGRRRRRGRGRGRGR",
      "GRGRRRRRRRGRGRGR",
      "GRGRGGGRRRGRRRGR",
      "RRGRGRGRRRGRRRGR",
      "RRGRRRGRRRGRRRGR",
      "RRGRRRGRRRGRRRGR",
      "GRGGGRGGGRGGGRGG"
    ],
    "CommentCount": 40,
    "DifficultyVoteCount": 52,
    "DifficultyVoteSum": 235,
    "Disliked": 0,
    "Featured": false,
    "Id": 257,
    "Items": [
      "################",
      "########...#####",
      "########.#.#####",
      "########.#.#...#",
      "########.#.#.#.#",
      "...#####.#.#.#.#",
      ".#.#####.#.#.#.#",
      ".#.#...#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#.#.#.#.#.#.#.#",
      ".#...#...#...#.*"
    ],
    "Liked": 55,
    "RobotCol": 0,
    "RobotDir": 0,
    "RobotRow": 11,
    "Solutions": 318,
    "SubLengths": [10, 10, 5, 5, 0],
    "SubmittedBy": "snydej",
    "SubmittedDate": "2009-04-02T05:50:12.627",
    "Title": "Winding Path"
  },
  {
    "About": "Play the first half, then rewind.",
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRBRRRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RRRRRRBBBBBBBRRR",
      "RRRRRRBBBBBRRRRR",
      "RRRRRRBRRRRRRRRR",
      "RRRRRBBBRRRRRRRR",
      "RRRRRBBBBBBBRRRR",
      "RRRRRBBBBBBBBBRR",
      "RRRRRBBBRRRRRRRR",
      "RRRRRBBBBBRRRRRR",
      "RRRRRBBBRRRRRRRR"
    ],
    "CommentCount": 2350,
    "DifficultyVoteCount": 104,
    "DifficultyVoteSum": 453,
    "Disliked": 2,
    "Featured": false,
    "Id": 66,
    "Items": [
      "#####..*########",
      "#####*...*######",
      "#####*.*########",
      "#####*.......*##",
      "#####*.....*####",
      "#####*.*########",
      "#####*.*########",
      "#####*.....*####",
      "#####*.......*##",
      "#####*.*########",
      "#####*...*######",
      "#####*.*########"
    ],
    "Liked": 114,
    "RobotCol": 5,
    "RobotDir": 0,
    "RobotRow": 0,
    "Solutions": 819,
    "SubLengths": [4, 5, 4, 4, 4],
    "SubmittedBy": "stingray",
    "SubmittedDate": "2009-02-27T02:19:51.47",
    "Title": "Reflection"
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRBBBRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 7,
    "DifficultyVoteSum": 9,
    "Disliked": 2,
    "Featured": false,
    "Id": 16162,
    "Items": [
      "################",
      "################",
      "#######..*######",
      "#######..*######",
      "#######..*######",
      "#######..*######",
      "#######.**######",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 2,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 65,
    "SubLengths": [10, 0, 0, 0, 0],
    "SubmittedBy": "hiitsme",
    "SubmittedDate": "2023-10-02T15:29:53.893",
    "Title": "Lightbot 1-4",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRBRRR",
      "RRRRRRRRRRRBBRRR",
      "RRRRRRRRRRBBRRRR",
      "RRRRRRRRRBBRRRRR",
      "RRRRRRRRBBRRRRRR",
      "RRRRRRRBBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 24,
    "DifficultyVoteSum": 27,
    "Disliked": 6,
    "Featured": false,
    "Id": 13924,
    "Items": [
      "################",
      "############*###",
      "###########..###",
      "##########..####",
      "#########..#####",
      "########..######",
      "#######..#######",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 23,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 195,
    "SubLengths": [4, 2, 0, 0, 0],
    "SubmittedBy": "same",
    "SubmittedDate": "2021-09-26T13:01:57.23",
    "Title": "Function Calls",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 38,
    "DifficultyVoteSum": 40,
    "Disliked": 13,
    "Featured": false,
    "Id": 14608,
    "Items": [
      "################",
      "################",
      "################",
      "######*****#####",
      "######*###*#####",
      "######*###*#####",
      "######*###*#####",
      "######.****#####",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 53,
    "RobotCol": 6,
    "RobotDir": 0,
    "RobotRow": 7,
    "Solutions": 580,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "Roses",
    "SubmittedDate": "2021-12-18T14:54:04.71",
    "Title": "Red square With a Hole 2.0",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 30,
    "DifficultyVoteSum": 33,
    "Disliked": 6,
    "Featured": false,
    "Id": 14288,
    "Items": [
      "################",
      "################",
      "################",
      "#######....*####",
      "#######...*.####",
      "#######..*..####",
      "#######.*...####",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 43,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 359,
    "SubLengths": [5, 0, 0, 0, 0],
    "SubmittedBy": "bjohn50",
    "SubmittedDate": "2021-10-04T22:05:20.933",
    "Title": "Selection",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRBRBRBRBRBRBRBR",
      "RRBRBRBRBRBRBRBR",
      "RRBRBRBRBRBRBRBR",
      "RRBRBRBRBRBRBRBR",
      "RBBBBBBBBBBBBBBR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 9,
    "DifficultyVoteSum": 12,
    "Disliked": 1,
    "Featured": false,
    "Id": 17297,
    "Items": [
      "################",
      "################",
      "##*#*#*#*#*#*#*#",
      "##.#.#.#.#.#.#.#",
      "##.#.#.#.#.#.#.#",
      "##.#.#.#.#.#.#.#",
      "#..............#",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 3,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 24,
    "SubLengths": [10, 5, 0, 0, 0],
    "SubmittedBy": "hiitsme4",
    "SubmittedDate": "2024-03-22T16:35:25.12",
    "Title": "Up and Back",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRBBBBBRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRBRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 7,
    "DifficultyVoteSum": 10,
    "Disliked": 1,
    "Featured": false,
    "Id": 17298,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "#######*########",
      "#######.########",
      "#####*...*######",
      "#######.########",
      "#######*########",
      "################",
      "################",
      "################",
    ],
    "Liked": 3,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 29,
    "SubLengths": [5, 3, 0, 0, 0],
    "SubmittedBy": "hiitsme4",
    "SubmittedDate": "2024-03-22T16:41:50.893",
    "Title": "Run Home",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "RRRRRRRRRRRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRBBRBBRRRRRR",
      "RRRRBBRRRBBRRRRR",
      "RRRBBRRRRRBBRRRR",
      "RRBBRRRRRRRBRRRR",
      "RRRBBRRRRRBBRRRR",
      "RRRRBBRRRBBRRRRR",
      "RRRRRBBRBBRRRRRR",
      "RRRRRRBBBRRRRRRR",
      "RRRRRRRRRRRRRRRR",
      "RRRRRRRRRRRRRRRR",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 44,
    "DifficultyVoteSum": 70,
    "Disliked": 1,
    "Featured": false,
    "Id": 14010,
    "Items": [
      "#######*########",
      "######...#######",
      "#####..#..######",
      "####..###..#####",
      "###..#####..####",
      "##..#######.*###",
      "###..#####..####",
      "####..###..#####",
      "#####..#..######",
      "######...#######",
      "#######*########",
      "################",
    ],
    "Liked": 55,
    "RobotCol": 2,
    "RobotDir": 0,
    "RobotRow": 5,
    "Solutions": 434,
    "SubLengths": [6, 0, 0, 0, 0],
    "SubmittedBy": "bli62",
    "SubmittedDate": "2021-09-30T13:02:26.15",
    "Title": "Black Diamond",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 1,
    "DifficultyVoteSum": 2,
    "Disliked": 0,
    "Featured": false,
    "Id": 18000,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "#####.....######",
      "#####.###.######",
      "#####.#...######",
      "#####.##########",
      "#####*##########",
      "################",
      "################",
      "################",
    ],
    "Liked": 55,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 434,
    "SubLengths": [4, 3, 5, 0, 0],
    "SubmittedBy": "hiitsme4",
    "SubmittedDate": "2024-06-20T12:11:49.28",
    "Title": "Variable Steps",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 1,
    "DifficultyVoteSum": 3,
    "Disliked": 0,
    "Featured": false,
    "Id": 18001,
    "Items": [
      "################",
      "################",
      "################",
      "################",
      "################",
      "######......####",
      "######.####.####",
      "#......####..*##",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 55,
    "RobotCol": 1,
    "RobotDir": 0,
    "RobotRow": 7,
    "Solutions": 434,
    "SubLengths": [9, 5, 2, 0, 0],
    "SubmittedBy": "hiitsme4",
    "SubmittedDate": "2024-06-20T13:42:18.28",
    "Title": "Many Functions",
  },
  {
    "AllowedCommands": 0,
    "Colors": [
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
      "BBBBBBBBBBBBBBBB",
    ],
    "CommentCount": 0,
    "DifficultyVoteCount": 1,
    "DifficultyVoteSum": 3,
    "Disliked": 0,
    "Featured": false,
    "Id": 18002,
    "Items": [
      "################",
      "################",
      "#######*########",
      "#######.########",
      "#######.########",
      "#######.########",
      "#######....*####",
      "################",
      "################",
      "################",
      "################",
      "################",
      "################",
    ],
    "Liked": 55,
    "RobotCol": 7,
    "RobotDir": 0,
    "RobotRow": 6,
    "Solutions": 434,
    "SubLengths": [4, 5, 0, 0, 0],
    "SubmittedBy": "hiitsme4",
    "SubmittedDate": "2024-06-20T14:02:06.28",
    "Title": "Turn the correct way",
  },
]

export default Boards;
